<template>
  <div class="page-wrapper m-lg-4" v-cloak>
    <div class="order-wrapper" v-if="order  && order.id">
      <div class="d-flex justify-content-between align-items-center">
        <template v-if="is_quote_order">
          <div class="fs-4 font-weight-bolder order-title p-2">Quote pending</div>
        </template>
        <template v-else>
          <template v-if="order.order_no">
            <div class="fs-4 font-weight-bolder order-title p-2">Order # {{order.order_no}}</div>
          </template>
          <template v-else>
            <div class="fs-4 font-weight-bolder order-title p-2">Order pending confirmation</div>
          </template>
        </template>
        <div class="font-weight-bolder d-flex order-title p-2">
          <template v-if="is_quote_order && show_quote_buttons">
            <button class="btn btn-secondary mx-2 cursor-pointer fs-2" @click="acceptQuote()">Accept Quote</button>
            <button class="btn btn-danger mx-2 cursor-pointer fs-2" @click="rejectQuote()" >Reject Quote</button>
          </template>

          <button v-if="show_provide_quote_button"
                  class="btn btn-secondary mx-2 cursor-pointer fs-2"  @click="provideQuotePrice(order)">Provide Quote</button>

        </div>
      </div>

      <b-tabs content-class="mt-3">

        <b-tab :key="`oi-${oiIdx}`" v-for="(order_item, oiIdx) in order.items">

          <template #title>
            {{ $can('order-detail-show-factory-name') ? (order_item.factory_id ? order_item.factory_name : 'No Factory') : 'Factory ' + parseInt(oiIdx + 1) }}
          </template>
          <OrderFlowStatusLine v-if="!is_quote_order" :item_status="order_item.status" />

          <div class="order-activities">
            <template v-if="$can('move-order')">
              <div :title="order_item.factory_id ? 'Move Order' : 'Order cannot be moved until it is assigned to a factory.'">
                <b-input-group  prepend="Move Order : " style="max-width: 700px; width: 100%; margin: 0 auto 20px;">
                  <b-form-select v-model="move_order_to_status" :options="moveOrderOptions" :disabled="!order_item.factory_id"></b-form-select>
                  <b-form-input v-model="move_order_reason" placeholder="Move order reason"></b-form-input>
                  <b-input-group-append>
                    <b-button variant="info" @click="order_item.factory_id ? moveOrderStatus(order_item, oiIdx) : ''"
                              :disabled="!order_item.factory_id">
                      Move
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </div>
            </template>

            <template v-for="(item_status_activity, isaIdx) in order_item.status_activities">
              <template v-if="isaIdx==0">
                <div :key="`isaf-${isaIdx}`">
                  <div  v-if="(order_item.status == FACTORYAPPROVED && item_status_activity.status == FACTORYAPPROVED)" class="comment-button d-flex text-left flex-wrap px-2 gap-2" style="margin-bottom: 10px">
                    <button @click="uploadSampleFiles(order_item, oiIdx)"  class="btn btn-secondary fs-2">
                      <svg  viewBox="0 0 16 16" width="1em" height="1em" focusable="false" role="img" aria-label="upload" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-upload mr-1 b-icon bi"><g><path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"></path><path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z"></path></g></svg>
                      Upload Design Sample
                    </button>
                  </div>

                  <div v-if="(order_item.status == CUSTOMERAPPROVED && item_status_activity.status == CUSTOMERAPPROVED || order_item.status == PRODUCTIONFILESUPLOADED && item_status_activity.status == PRODUCTIONFILESUPLOADED) && $can('put-order-in-production') && !isPutInProduction" class="comment-button d-flex text-left flex-wrap px-2 gap-2" style="margin-bottom: 10px">
                    <button  @click="handlePutInProduction(order_item)" class="btn btn-secondary fs-2">
                      <svg data-v-3c1ef684="" viewBox="0 0 16 16" width="1em" height="1em" focusable="false" role="img" aria-label="printer" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-printer mr-1 b-icon bi"><g data-v-3c1ef684=""><path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"></path><path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z"></path></g></svg>
                      Put In Production
                    </button>    
                  </div>
                  <div v-if="isPutInProduction" class="comment-button d-flex flex-column px-2 my-3">
                    <b-form-datepicker style="margin-bottom: 5px" class="w-25" v-model="est_shipping_date" placeholder="Enter Est. Shipping Date"></b-form-datepicker>
                    <div class="d-flex text-left flex-wrap gap-1">
                      <button  @click="putOrderInProduction(ORDERINPRODUCTION, order_item, order, oiIndex, true, false)" class="btn btn-secondary">
                        Save and notify
                      </button>
                      <button  @click="putOrderInProduction(ORDERINPRODUCTION, order_item, undefined, false, false )" class="btn btn-secondary">
                        Save without notifying
                      </button>
                      <button  @click="isPutInProduction = false" class="btn btn-secondary fs-2">
                        cancel
                      </button>
                    </div>
                  </div>
                </div>
              </template>

              <div class="activity-status" :key="`isa-${isaIdx}`">

                <ActivityStatusIcons :activity_status="item_status_activity.status" />

                <div class="activity-content">
                  <div class="activity-title">
                    {{
                      item_status_activity.status === FACTORYREVIEW && (isaIdx + 1) !== order_item.status_activities.length ?
                          "Artwork Updated" :
                          activityStatus[item_status_activity.status].title
                    }}
                    <span class="date-time">
                        <!-- {{ item_status_activity.created_at | formatDate('HH:mm Do MMM YY ')  }} -->
                        {{ formatedDate(item_status_activity.created_at) }}
                    </span>
                    <template v-if="item_status_activity.action_log && item_status_activity.action_log.manual_action">
                      <span class="date-time" v-if="item_status_activity.action_log && item_status_activity.action_log.manual_action"> - </span>
                      <span class="date-time">Moved by {{item_status_activity.user?.name}}</span>
                      <span class="date-time" v-if="item_status_activity.action_log && item_status_activity.action_log.reason">: </span>
                      <span class="date-time" v-if="item_status_activity.action_log && item_status_activity.action_log.reason">"{{item_status_activity.action_log.reason}}"</span>
                    </template>
                  </div>
                  <template v-if="item_status_activity.status === ORDERINPRODUCTION || item_status_activity.status === CUSTOMERREVIEW">
                    <div class="activity-text p-2 fs-2 text-muted" v-html="activityStatus[item_status_activity.status].message">
                    </div>
                  </template>
                  <template v-else>
                    <div class="activity-text p-2 fs-2 text-muted">
                      {{ activityStatus[item_status_activity.status].message }}
                    <div v-if="item_status_activity.status == QUALITYCONTROL" >
                            <span class="badge" :class="{
                              'badge-success': item_status_activity.quality_control_status == 'Approved',
                              'badge-danger': item_status_activity.quality_control_status == 'Rejected',
                              'badge-warning': item_status_activity.quality_control_status == 'Pending',
                            }">{{ item_status_activity.quality_control_status }}</span>
                          </div>  
                    </div>
                  </template>
                  <template v-if="order_item.est_shipping_date && item_status_activity.status === ORDERINPRODUCTION">
                    <div class="shipping-dates-container ml-3">
                      <div class="shipping-dates-wrapper">
                        <ul class="shipping-dates">
                          <li class="shipping-dates-list" v-for="(date, date_idx) in reversedEstShippingDates(order_item)" :key="`shipping_date_${date_idx}`">
                            <span class="text-muted" v-if="date_idx == order_item.est_shipping_date.length - 1"><strong class="font-weight-bold">Estimated shipping date:</strong> {{ date }}</span>
                            <span class="text-muted" v-else><strong class="font-weight-bold">Updated estimated shipping date:</strong> {{ date }}</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </template>
                  <div class="images-grid py-2 gap-1 d-flex">
                    <div class="d-flex flex-wrap gap-1">
                      <template v-for="(activity_item,aiIdx) in item_status_activity.activity_items">
                       
                        <div :key="aiIdx">
                           
                         
                          <!--    
                                              <div :key="aiIdx" class="d-flex align-items-start flex-column position-relative skipped" :class="(activity_item.activity_files && activity_item.activity_files.length > 0)? 'submit-block': '' "-->
                          <div  class="d-flex align-items-start flex-column position-relative skipped-block" :class="evaluateClass(activity_item, item_status_activity.status)"
                              @click="showPreview(activity_item,activity_item.factory_product_id)"
                          >
<div
                            v-if="item_status_activity.status == CUSTOMERREVIEW && activity_item.third_party_approval_obj && activity_item.third_party_approval_obj.approval_status"
                            class="mb-2">
                            <span class="badge" :class="{
                              'badge-warning': activity_item.third_party_approval_obj.approval_status === 'pending',
                              'badge-success': activity_item.third_party_approval_obj.approval_status === 'accepted',
                              'badge-danger': activity_item.third_party_approval_obj.approval_status === 'rejected'
                            }">
                              Third Party Status:
                              {{
                                activity_item.third_party_approval_obj.approval_status.charAt(0).toUpperCase() +
                                activity_item.third_party_approval_obj.approval_status.slice(1)
                              }}
                            </span>
                          </div>
                            <div class="d-flex">
                              <template  v-for="(activity_file, afIdx) in activity_item.activity_files">
                <template v-if="activity_file.url && activity_file.url != 'null'">
                                <template v-if="['jpg', 'jpeg', 'png','bmp', 'svg'].includes(getFileExtension(activity_file.url))">
                                  <img :src="`${storage_url}/${activity_file.url}`" alt="" :key="`af-${afIdx}${aiIdx}`" >
                                </template>
                                <template v-else>
                                  <b-icon-file-earmark :key="`af-${afIdx}${aiIdx}`"  style="width:150px;height:150px"/>
                                </template>
                  </template>
                              </template>

                              <div class="actions nested-actions" v-if="activity_item.activity_files && activity_item.activity_files.length > 0" :key="`details-btn-${aiIdx}`">

                                <button class="order-detail-btn btn btn-secondary btn-sm" title="Download images"
                                        @click.stop="downloadActivityProductionFile(activity_item.activity_files)"
                                        style="padding: 3px 5px !important;"
                                        v-if="item_status_activity.status == PRODUCTIONFILESUPLOADED"
                                >
                                  <svg style="width:1em;height:1em" viewBox="0 0 24 24">
                                    <path fill="currentColor" d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z" />
                                  </svg>
                                </button>
                                

                                <button class="order-detail-btn btn btn-secondary btn-sm" style="padding: 3px 5px !important;" :key="`preview-btn-${aiIdx}`"
                                        @click.stop="showOrderDetails($event,order_item,activity_item.factory_product_id,true)"
                                        v-if="item_status_activity.status == FACTORYREVIEW"
                                >
                                  <svg style="width:1em;height:1em" viewBox="0 0 24 24">
                                    <path fill="currentColor" d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z" />
                                  </svg>

                                </button>

                                <button class="btn btn-secondary btn-sm" title="View details" style="padding: 3px 5px !important;" @click="showOrderDetails($event, order_item, activity_item.factory_product_id, false)">
                                  <b-icon-list-ul />
                                </button>



                              </div>
                            </div>
                            <div class="comment-row px-2 pb-2 d-flex gap-1 mt-1"
                                v-if="order.additional_fields && order.additional_fields.is_manual_order">
                              <strong class="font-weight-bold">Nick Name:</strong>
                              <span class="text-muted font-weight-bold">{{ order_item.factory_products[aiIdx]?.design_nick_name }}</span>
                            </div>
                            <div class="comment-row px-2 pb-2 d-flex gap-1 mt-1"
                                v-if="order_item.factory_products[aiIdx]?.design_id && activity_item.activity_files && activity_item.activity_files.length > 0">
                              <strong class="font-weight-bold">Design ID:</strong>
                              <span class="text-muted font-weight-bold">{{ order_item.factory_products[aiIdx]?.design_id }}</span>
                            </div>
                            <div
  v-if="activity_item.third_party_approval_obj && activity_item.third_party_approval_obj.approval_status === 'rejected' && activity_item.third_party_approval_obj.feedback"
  class="feedback-ui-enhanced mt-2">
  <div class="feedback-title">
    <span class="text-danger mr-2 font-weight-bold" > Rejection Feedback</span>

  </div>
  <div class="feedback-body">
    {{ activity_item.third_party_approval_obj.feedback }}
  </div>
</div>
                            <div class="feedback-text align-items-start mt-2 d-flex"
                                v-if="item_status_activity.status != PRODUCTIONFILESUPLOADED && order_item.factory_products[aiIdx]?.addons && order_item.factory_products[aiIdx]?.addons.length > 0">
                              <div><strong>Addons:</strong></div>
                              <div>
                                <ul class="list-unstyled d-flex flex-wrap mt-1 mb-0 gap-1" style="max-width: 350px">
                                  <template v-for="factory_product_addon in order_item.factory_products[aiIdx]?.addons">
                                    <span class="badge badge-light fs-1"
                                          :key="`factory_product_${order_item.factory_products[aiIdx].id}_addon_${factory_product_addon.addon_id}`">
                                      {{ factory_product_addon.title }}
                                    </span>
                                  </template>
                                </ul>
                              </div>
                            </div>
                            <div class="feedback-text align-items-start mt-2 d-flex"
                                v-if="activity_item.skip_customer_approval && activity_item.skip_customer_approval.reason && !(activity_item.skip_customer_approval.reason === null || activity_item.skip_customer_approval.reason === 'null' || activity_item.skip_customer_approval.reason === '')">
                              <div><strong>Skip Reason:</strong></div>
                              <div>
                                    <span class="badge badge-light fs-1"
                                          :key="`skipped_reason_${aiIdx}`">
                                      {{ activity_item.skip_customer_approval.reason }}
                                    </span>
                              </div>
                            </div>
                            <div class="feedback-text" v-if="(item_status_activity.status == ORDERSHIPPED && aiIdx == 0 && order_item.tracking_link)" :key="`afd-${aiIdx}`">The shipping link is <a :href="order_item.tracking_link" target="_blank">{{order_item.tracking_link}}</a>.</div>
                            <template v-else >
                              <div class="feedback-text d-flex" :key="`afd-${aiIdx}`" v-if="activity_item.message && activity_item.message!='' ">
                                <div><strong>Feedback:</strong> </div>
                                <div>{{activity_item.message}}</div>
                              </div>
                            </template>
                            <template v-if="item_status_activity.status == FACTORYREVIEW">
                              <span>{{makeReorderMessage(activity_item.factory_product_id, order_item.factory_products)}}</span>
                            </template>
                          </div>
                          
                      </div>
                      </template>

                    </div>
                    <template v-if="isaIdx==0">
                      <div class="actions" v-if="order_item.status == FACTORYREVIEW && item_status_activity.status == FACTORYREVIEW">
                        <button class="btn btn-secondary" @click="makeActivityData(order_item, oiIdx, ORDERAPPROVE, true)" v-if="$can('mark-to-factory')">Mark To Factory</button>
                        <button class="btn btn-secondary" @click="makeActivityData(order_item, oiIdx, ORDERCANCEL, false)" v-if="$can('cancel-order')">
                          Cancel Order
                        </button>
                      </div>

                      <div class="actions" v-if="order_item.status == ORDERAPPROVE && item_status_activity.status == ORDERAPPROVE && order_item.factory_id">
                        <button class="btn btn-secondary" @click="showArtworkDesigns(order_item, oiIdx, isaIdx)" v-if="$can('update-order')">Take action</button>
                      </div>

                      <div class="actions" v-if="(order_item.status == CUSTOMERREVIEW && item_status_activity.status == CUSTOMERREJECTED)">
                        <button class="btn btn-secondary" @click="uploadSampleFiles(order_item, oiIdx, isaIdx)" v-if="$can('update-order')">Take action</button>
                      </div>
                     
                      <div v-if="(order_item.status == ORDERSHIPPED && item_status_activity.status == ORDERSHIPPED)" class="comment-button d-flex flex-column text-left flex-wrap px-2 gap-2">
                        <button  @click="makeActivityData(order_item, oiIdx, ORDERCOMPLETED, false)" class="btn btn-secondary">
                          <svg data-v-3c1ef684="" viewBox="0 0 16 16" width="1em" height="1em" focusable="false" role="img" aria-label="cursor" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-cursor mr-1 b-icon bi"><g data-v-3c1ef684=""><path d="M14.082 2.182a.5.5 0 0 1 .103.557L8.528 15.467a.5.5 0 0 1-.917-.007L5.57 10.694.803 8.652a.5.5 0 0 1-.006-.916l12.728-5.657a.5.5 0 0 1 .556.103zM2.25 8.184l3.897 1.67a.5.5 0 0 1 .262.263l1.67 3.897L12.743 3.52 2.25 8.184z"></path></g></svg>
                          Complete Order
                        </button>
                      </div>
                    </template>
                  </div>
                  <template v-if="item_status_activity.status == QUALITYCONTROL">
                            <div v-for="(report, index) in item_status_activity.quality_control_reports" :key="`report-${index}`" >
                            {{ index + 1 }}. QC report {{report.status}}: <a :href="report.pdf_url" target="_blank">
                                {{ report.pdf_name }} 
                              </a> submitted at {{ report.created_at | formatDate('DD/MM/YYYY  ') }}
                            </div>
                          
                          </template>
                  <div class="d-flex gap-2" v-if="isaIdx==0">
                    
                    <div v-if="(order_item.status == ORDERINPRODUCTION && item_status_activity.status == ORDERINPRODUCTION) || 
                      (item_status_activity.status == QUALITYCONTROL)" class="comment-button d-flex text-left flex-wrap px-2 gap-2">
                        <button v-if="!entershipping && $can('enter-order-shipping')"  @click="entershipping = true" class="btn btn-secondary shipping-btn">
                          <svg data-v-3c1ef684="" viewBox="0 0 16 16" width="1em" height="1em" focusable="false" role="img" aria-label="truck" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-truck mr-1 b-icon bi"><g data-v-3c1ef684=""><path d="M0 3.5A1.5 1.5 0 0 1 1.5 2h9A1.5 1.5 0 0 1 12 3.5V5h1.02a1.5 1.5 0 0 1 1.17.563l1.481 1.85a1.5 1.5 0 0 1 .329.938V10.5a1.5 1.5 0 0 1-1.5 1.5H14a2 2 0 1 1-4 0H5a2 2 0 1 1-3.998-.085A1.5 1.5 0 0 1 0 10.5v-7zm1.294 7.456A1.999 1.999 0 0 1 4.732 11h5.536a2.01 2.01 0 0 1 .732-.732V3.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .294.456zM12 10a2 2 0 0 1 1.732 1h.768a.5.5 0 0 0 .5-.5V8.35a.5.5 0 0 0-.11-.312l-1.48-1.85A.5.5 0 0 0 13.02 6H12v4zm-9 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm9 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"></path></g></svg>
                          Enter Shipping Details
                        </button>
                        <div v-if="entershipping">
                          <template v-if="order_item.tracking_no == null">
                            <b-input-group style="margin-bottom: 5px">
                              <b-form-select v-model="activity_items.shipping_company" @input="setTrackingLink($event,'company')"
                                             :options="getShippingOptions"></b-form-select>
                            </b-input-group>
                            <b-form-input @input="setTrackingLink($event,'number')" style="margin-bottom: 5px" class="w-100" :value="order_item.tracking_no" v-model="activity_items.tracking_no" placeholder="Enter Tracking Number"></b-form-input>
                            <b-form-input class="w-200" v-model="activity_items.tracking_link" placeholder="Enter shipping link" :value="order_item.tracking_link"></b-form-input>
                            <button  @click="makeActivityData(order_item, oiIdx, ORDERSHIPPED, false)" class="btn btn-secondary" style="margin:5px">
                              Save
                            </button>
                            <button  @click="entershipping = false" class="btn btn-secondary fs-2" style="margin:5px">
                              cancel
                            </button>
                          </template>
                          <template v-else>
                            <div>{{order_item.shipping_company}}</div>
                            <div><a target="_blank" :href="order_item.tracking_link"> {{order_item.tracking_no}}</a></div>

                          </template>
                        </div>
                      </div>
                      <div v-if="(order_item.status == ORDERINPRODUCTION && item_status_activity.status == ORDERINPRODUCTION)  || 
                      (item_status_activity.status == QUALITYCONTROL)" class="comment-button d-flex text-left flex-wrap px-2 gap-2">
                        <button v-if="!enterShippingDates && $can('enter-shipping-date')" @click="handleEnterShippingDate(order_item)" class="btn btn-secondary shipping-btn">
                          <b-icon-calendar-date /> Enter shipping date
                        </button>
                        <div v-if="enterShippingDates">
                          <template>
                            <b-form-datepicker style="margin-bottom: 5px" class="w-100" v-model="est_shipping_date" placeholder="Enter Est. Shipping Date"></b-form-datepicker>
                            <button  @click="addShippingDate(ORDERINPRODUCTION, order_item, order, true)" class="btn btn-secondary" style="margin:5px">
                              Save and notify
                            </button>
                            <button  @click="addShippingDate(ORDERINPRODUCTION, order_item)" class="btn btn-secondary" style="margin:5px">
                              Save without notifying
                            </button>
                            <button  @click="enterShippingDates = false" class="btn btn-secondary fs-2" style="margin:5px">
                              cancel
                            </button>
                          </template>
                        </div>
                      </div>

                  </div>
                  <div class="comment-row px-2 pb-2 d-flex gap-1 mt-1"
                       v-if="order.general_comments && isaIdx === 0">
                    <strong class="font-weight-bold">General Comments:</strong>
                    <span class="text-muted">{{ order.general_comments }}</span>
                  </div>
                  <div class="comment-row px-2 pb-2 d-flex gap-1 mt-1"
                       v-if="order.additional_fields && order.additional_fields.po_number && isaIdx === 0">
                    <strong class="font-weight-bold">PO Number:</strong>
                    <span class="text-muted">{{ order.additional_fields.po_number }}</span>
                  </div>
                  <div class="comment-row px-2 pb-2 d-flex gap-1 mt-1"
                       v-if="order.additional_fields && order.additional_fields.is_manual_order && isaIdx === 0">
                    <strong class="font-weight-bold">Customer Reference No:</strong>
                    <span class="text-muted">{{ order.customer_reference_no }}</span>
                  </div>
                  <div class="comment-row px-2 pb-2 d-flex gap-1 mt-1"
                       v-if="order.quote_text && item_status_activity.status == QUOTEPROVIDED">
                    <strong class="font-weight-bold">Quote provided price:</strong>
                    <span class="text-muted">{{ order.quote_text }}</span>
                  </div>
                  <div class="comment-button text-left px-2" v-if="isaIdx == 0">
                    <a class="text-info" @click="item_status_activity.add_comment = !item_status_activity.add_comment"><BIconChatDots /> Add comment</a>
                  </div>
                  <!-- add comment starts -->
                  <template v-if="item_status_activity.add_comment">
                    <AddUpdateComment :url="`order_item/${item_status_activity.id}/comment`"
                                      :order_item_id="`${order_item.id}`"
                                      v-on:hideCommentBox = "hideCommentBox(item_status_activity, 'add_comment')"
                                      v-on:commentActionCompleted = "item_status_activity.comments.unshift($event)"
                    ></AddUpdateComment>

                  </template>
                  <!-- add comment ends -->

                  <!-- Comment listing starts -->
                  <template v-for="(activity_comment, activity_comment_index) in item_status_activity.comments">
                    <div class="comment-row px-2 pb-2 d-flex gap-1 mt-3" :key="`activity_comment_${activity_comment_index}`"
                         v-if="!activity_comment.edit_comment && !activity_comment.reply_comment">
                      <div class="d-flex gap-1">
                      <span class="comment-avatar">
                        {{ activity_comment.user ? `${activity_comment.user.name}` : "" | initials }}
                      </span>
                        <div class="comment-msg">
                          <!-- Comment action buttons starts -->
                          <div class="comment-action" :class="{ 'resolved-comment': !activity_comment.action_taken }" style="right: -450px">
                            <ul class="fs-1 d-flex gap-1">
                              <li v-if="$can('can-resolve-comment') && (!(activity_comment && activity_comment.hasOwnProperty('user') && activity_comment.user && Array.isArray(activity_comment.user.userroles)) || (activity_comment.user.userroles[0].name !== 'SuperAdmin' && activity_comment.user.userroles[0].name !== 'OrderAdministrator'))">
                                <template v-if="(activity_comment.action_taken === 1 && !activity_comment.action_taken_by)">
                                  <b-form-checkbox class="w-75" :value="1" :unchecked-value="0" @change="takeCommentAction(activity_comment)" v-model="activity_comment.action_taken">
                                    NA
                                  </b-form-checkbox>
                                </template>
                                <template v-else>
                                  <b-form-checkbox class="w-75" :value="1" :unchecked-value="0" @change="takeCommentAction(activity_comment)" v-model="activity_comment.action_taken">
                                    {{ activity_comment.action_taken ? `Resolved by ${activity_comment.action_taken_by} at ${$options.filters.formatDate(activity_comment.action_taken_at, 'HH:mm Do MMM YY')}` : 'Take Action' }}
                                  </b-form-checkbox>
                                </template>
                              </li>
                              <li>
                                <a @click="activity_comment.reply_comment = !activity_comment.reply_comment">
                                  <BIconReply/>
                                  Reply
                                </a>
                              </li>
                              <li v-if="canPerformCommentAction(activity_comment)">
                                <a @click="activity_comment.edit_comment = !activity_comment.edit_comment">
                                  <BIconPencil/>
                                  Edit
                                </a>
                              </li>
                              <li v-if="canPerformCommentAction(activity_comment)">
                                <a @click="deleteComment(activity_comment,item_status_activity)">
                                  <BIconTrash/>
                                  Delete
                                </a>
                              </li>
                            </ul>
                          </div>
                          <!-- Comment action buttons ends -->

                          <blockquote class="blockquote mb-0">
                            <footer class="blockquote-footer" v-if="activity_comment.parent_message_id">
                              <cite title="Source Title" v-html="activity_comment.parent_message"></cite>
                            </footer>
                          </blockquote>

                          <p v-html="linkifyText(activity_comment.message)"></p>


                          <div class="d-flex align-items-center gap-1">
                            <template v-for="(activity_comment_file, activity_comment_file_index) in activity_comment.files">
                              <template v-if="['jpg', 'jpeg', 'png','bmp', 'svg'].includes(activity_comment_file.extension)">
                                <a target="_blank" :key="`activity_comment_file_${activity_comment_file_index}`" class="d-inline-block"
                                   :href="`${storage_url}/${activity_comment_file.url}`" :alt="`${activity_comment_file.name}`" style="width:70px;height:50px">
                                  <img class="rounded comment-image" :src="`${storage_url}/${activity_comment_file.url}`" :alt="`${activity_comment_file.name}`">
                                </a>
                              </template>
                              <template v-else>
                                <a :key="`activity_comment_file_${activity_comment_file_index}`" :href="activity_comment_file.file_preview" download target="_blank">
                                  <button v-if="['jpg', 'jpeg', 'png','bmp', 'svg'].includes(activity_comment_file.name)" class="btn btn-secondary" disabled style="width:50px;height:50px"><span class="spinner-border" style="width:100%;height:100%"></span></button>
                                  <button v-else-if="['pdf'].includes(activity_comment_file.extension)" class="btn btn-secondary" @click.prevent="downloadAttachment(activity_comment_file)" style="width:50px;height:50px;position:relative"><img class="rounded" style="max-height: 33px;width:100%;height:100%;position: absolute;top:7px;left:0;" src="/img/images/pdf-placeholer.png"/></button>
                                  <button v-else class="btn btn-secondary" @click.prevent="downloadAttachment(activity_comment_file)" style="width:50px;height:50px"><b-icon-file-earmark style="width:100%;height:100%"/></button>
                                </a>
                              </template>
                            </template>
                          </div>
                          <div class="d-flex justify-content-end">
                            <span> <small class="text-muted">{{ evaluateRole(activity_comment) }}</small> </span>
                          </div>
                        </div>
                        <div>

                        </div>
                      </div>
                      <div class="comment-time">
                        <!-- {{ activity_comment.created_at | formatDate('HH:mm Do MMM YY ') }} -->
                        {{ formatedDate(activity_comment.created_at) }}
                      </div>
                    </div>
                    <!--  edit comment starts -->
                    <template v-if="activity_comment.edit_comment">
                      <AddUpdateComment :key="`activity_comment-edit-${activity_comment_index}`" action="edit"
                                        v-on:hideCommentBox = "hideCommentBox(activity_comment, 'edit_comment')"
                                        v-on:commentActionCompleted="handleCommentActionCompleted($event, item_status_activity, activity_comment_index)"
                                        :comment_obj="activity_comment" :url="`order_item/${item_status_activity.id}/comment/${activity_comment.id}`"
                                        :order_item_id="`${order_item.id}`"
                      ></AddUpdateComment>
                    </template>
                    <!--  edit comment ends -->

                    <!--  add reply starts -->
                    <AddUpdateComment :key="`activity_comment-edit-${activity_comment_index}`" action="reply" v-if="activity_comment.reply_comment"                  
                                      v-on:hideCommentBox = "hideCommentBox(activity_comment, 'reply_comment')"
                                      v-on:commentActionCompleted = "item_status_activity.comments.unshift($event)"
                                      :comment_obj="activity_comment" :url="`order_item/${item_status_activity.id}/comment`"
                                      :order_item_id="`${order_item.id}`"
                    ></AddUpdateComment>
                    <!--  add reply ends -->

                  </template>
                  <!-- Comment listing ends -->

                </div>
              </div>
            </template>
          </div>
        </b-tab>
        <b-tab :key="`oi-${order.id}`" title="Files" v-if="order_factories.length > 0 && $can('sharepoint-files')">
          <div class="order-activities">
            <FileView :order_id="order.id" :order_factories="order_factories"/>
          </div>
        </b-tab>  
      </b-tabs>


    </div>

    <div v-if="no_custimo_order">
      <span class="alert alert-danger">This is not a custimoo order.</span>
    </div>

    <modal :width="1300"
           :resizable="true"
           :scrollable="true"
           height="auto"
           :reset="true"
           :clickToClose="false"
           name="order-detail" ref="order-detail" id="order-detail" size="xl" :hide-footer="true">

      <div class="modal-header fs-4 d-flex justify-content-between p-3">
        <div class="font-weight-bold pl-1">
          Order Details
        </div>
        <span class="modal-close cursor-pointer" @click="closeFactoryDetail">
          <BIconX />
        </span>
      </div>
      <template v-if="factory_product && order && order.id">
        <div v-if="start_download_production_file" style="display: none;">
          <ProductionFileGenerator :designUrl="factory_product.production_design_url" :sizesUrl="factory_product.design_sizes_url"
          :safeZoneUrl="factory_product.design_safezone_url"
          :groupPatterns="factory_product.group_patterns" :custom_logos="factory_product.custom_logos"
          :texts="factory_product.product_custom_texts" :svgGroups="factory_product.svg_groups"
          :logos="factory_product.fixed_logos" @resetDownloadProductionFile="resetDownloadProductionFile"
          :sizeDownload="size_download"> </ProductionFileGenerator>
        </div>
        <cRow class="mt-3 mx-2">
          <cCol class="col-2">
            <strong>Company:</strong> {{order.hasOwnProperty('company_name')?order.company_name: ""}}
          </cCol>
          <cCol class="col-2">
            <strong>Customer:</strong> {{order.customer.first_name + order.customer.last_name}}
          </cCol>
          <cCol class="col-3">
            <strong>Email:</strong> {{order.customer.email}}
          </cCol>
          <cCol class="col-3">
            <strong>Product:</strong> {{factory_product.product_name}}
          </cCol>
          <cCol class="col-2">
            <template v-if="order.order_no">
              <a :href="`${api_url}/order/${order_id}/product/${factory_product.id}/export`"
                 :download="`order_${order.order_no}_product_${factory_product.product_name}.xlsx`"
                 class="btn btn-dark mx-1"
              >
                Download Excel sheet
              </a>
            </template>
            <template v-else>
              <a :href="`${api_url}/order/${order_id}/product/${factory_product.id}/export`"
                 :download="`order_${getCurrentDatetime()}_product_${factory_product.product_name}.xlsx`"
                 class="btn btn-dark mx-1"
              >
                Download Excel sheet
              </a>
            </template>
          </cCol>
        </cRow>
        <cRow class="mt-3 mx-2">
          <cCol class="col-6 order-detail-roster">
            <h4>Roster Detail</h4>
            <template v-if="factory_product && Object.prototype.hasOwnProperty.call(factory_product, 'product_roster_detail') && factory_product.product_roster_detail.length > 0">
              <b-table
                  :items="factory_product.product_roster_detail"
                  :fields="roster_headers"
                  hover
                  sorter
                  class="bg-gray-200"
              >
                <template #cell(download)="{item}">
                  <button class="btn" @click="getSizeProductionFile(item)"><b-icon-download size="sm"></b-icon-download></button>
                </template>
              </b-table>
            </template>
            <template v-else="">
              <cRow class="bg-gray-200">
                <cCol class="col-12">
                  No roster exists
                </cCol>
              </cRow>
            </template>
          </cCol>
          <cCol class="col-6">
            <div class="d-flex justify-content-between">
              <h4>Production Image</h4>

              <button
                  class="btn btn-dark mx-1"
                  @click.prevent="batchDownloadAssets"
                  v-if="!batch_loading"
              >
                Batch Download Assets
              </button>
              <button class="btn btn-dark mx-1" v-else>
                <span class="spinner-border"></span>
              </button>
            </div>

            <div class="w-100 mt-3">
              <div class="d-flex align-items-center justify-content-center w-100 gap-1">
                <template>
                  <img :src="this.storage_url+'/'+this.front_preview" class="flex-shrink-1" style="max-width: calc(50% - 0.5rem);" :key="this.front_preview" alt="">
                  <img :src="this.storage_url+'/'+this.back_preview" class="flex-shrink-1" style="max-width: calc(50% - 0.5rem);" :key="this.back_preview" alt="">
                </template>
              </div>

              <div class="px-3 pb-3 d-flex mt-1 gap-2 justify-content-center">
                <button class="btn btn-dark text-white" v-if="!loadingPreviewImages"  :disabled="!hasPreviewImages" @click="downloadImages">Download Preview Images</button>
                <button class="btn btn-dark text-white" v-else disabled><b-icon-arrow-counterclockwise class="b-icon-animation-spin-reverse" /> Please wait...</button>

                <a class="btn btn-dark text-white" @click="openAWSFileFromOrder(order)" v-if="$can('download-customer-pdf') && order.additional_fields && !order.additional_fields.hasOwnProperty('is_manual_order')">Download PDF</a>
              </div>
            </div>

            <template v-if="factory_product && factory_product.hasOwnProperty('production_url') && factory_product.production_url">
              <template v-if="order.order_no">
                <div @click="downloadProductionFile(factory_product.svg_url,`${order.order_no}.svg`)">
                  <img v-if="factory_product.svg_url" :src="`${storage_url}/${factory_product.svg_url}`" class="production-image" style="height: 100%;width: 100%;"/>
                  <span v-else v-html="production_content" class="production-image" ></span>
                </div>
              </template>
              <template v-else>
                <div @click="downloadProductionFile(factory_product.svg_url,`${getCurrentDatetime()}.svg`)">
                  <img v-if="factory_product.svg_url" :src="`${storage_url}/${factory_product.svg_url}`" class="production-image" style="height: 100%;width: 100%;"/>
                  <span v-else v-html="production_content" class="production-image" ></span>
                </div>
              </template>
            </template>
            <template v-else="">
              <cRow>
                <cCol class="col-12">
                  No image exists
                </cCol>
              </cRow>
            </template>
          </cCol>
        </cRow>
        <cRow class="mt-3 mx-2">
          <cCol class="col-6 mt-2">
            <cCol class="col-12">
              <h4>Custom Names</h4>
            </cCol>
            <template v-if="product_texts.length > 0">
              <b-table
                  :items="product_texts"
                  :fields="custom_text_headers"
                  hover
                  sorter
              >
              </b-table>
            </template>
            <template v-else="">
              <cRow>
                <cCol class="col-12">
                  No Custom Names Exists
                </cCol>
              </cRow>
            </template>
          </cCol>
          <cCol class="col-6 mt-2">
            <cCol class="col-12">
              <h4>Custom Numbers</h4>
            </cCol>
            <template v-if="product_numbers.length > 0">
              <b-table
                  :items="product_numbers"
                  :fields="custom_text_headers"
                  hover
                  sorter
              >
              </b-table>
            </template>
            <template v-else="">
              <cRow>
                <cCol class="col-12">
                  No Custom Numbers Exists
                </cCol>
              </cRow>
            </template>
          </cCol>
        </cRow>
        <cRow class="mt-3 mx-2">
          <cCol class="col-6 pt-2 bg-gray-200">
            <cCol class="col-12">
              <h4>Custom Logos</h4>
            </cCol>
            <template v-if="factory_product && factory_product.hasOwnProperty('custom_logos') && factory_product.custom_logos.length > 0">
              <b-table
                  :items="custom_logos"
                  :fields="custom_logos_headers"
                  hover
                  sorter
              >
                <template #cell(url)="data">
                  <img :src="`${storage_url}/${data.item.url}`" alt="" width="100" v-if="data.item.url">
                </template>
                <template #cell(side)="data">
                  <div v-if="data.item.id">{{data.item.side}}</div>
                </template>
                <template #cell(size)="data">
                  <template v-if="measurement_unit.unit === 'cm'">
                    <div v-if="data.item.id">{{data.item.originalWidth}} cm X {{data.item.originalHeight}} cm</div>
                  </template>
                  <template v-else-if="measurement_unit.unit === 'in'">
                    <div v-if="data.item.id">{{ parseFloat(data.item.originalWidth).toFixed(2)}}" X {{parseFloat(data.item.originalHeight).toFixed(2)}}"</div>
                  </template>
                </template>
                <template #cell(download)="data">
                  <div v-if="data.item.id">
                    <button class="btn btn-secondary mx-1" @click="downloadLogo(data.item.id,data.item.url)" v-if="logo_selected_id !== data.item.id">Download</button>
                    <button class="btn btn-secondary mx-1" v-else>
                      <span class="spinner-border"></span>
                    </button>
                    <template v-if="$can('vectorize-logo') && getFileExtensionType('raster', data.item.original_logo_url)">
                      <template v-if="data.item.vectorized_logo_info.show_vectorized_loader">
                        <span class="spinner-border"></span>
                      </template>
                      <template v-else>
                        <template v-if="data.item.vectorized_logo_info.vectorized_file_url">
                          <button class="btn btn-secondary mx-1" @click="downloadVectorizedFile(data.item.index, data.item)">Download Vectorized Logo</button>
                        </template>
                        <template v-else>
                          <button class="btn btn-secondary mx-1" @click="vectorizeLogo(data)">Vectorize Logo</button>
                        </template>
                      </template>
                      <template v-if="data.item.vectorized_logo_info.show_preview_loader">
                        <span class="spinner-border"></span>
                      </template>
                      <template v-else>
                        <template v-if="data.item.vectorized_logo_info.preview_file_url">
                          <button class="btn btn-secondary mx-1" @click="downloadVectorizedFile(data.item.index, data.item, true)">Download Vectorized Logo Preview</button>
                        </template>
                        <template v-else>
                          <button class="btn btn-secondary mx-1" @click="vectorizeLogo(data, true)">Preview Vectorized Logo</button>
                        </template>
                      </template>
                    </template>
                  </div>
                </template>
              </b-table>
            </template>
            <template v-else="">
              <cRow>
                <cCol class="col-12">
                  No Custom Logos Exists
                </cCol>
              </cRow>
            </template>
          </cCol>
          <cCol class="col-6 mt-5">

          </cCol>
        </cRow>
        <cRow class="mt-3 mx-2">
          <cCol class="col-6 mt-2">
            <cCol class="col-12">
              <h4>SVG Groups</h4>
            </cCol>
            <template v-if="factory_product && factory_product.hasOwnProperty('svg_groups') && factory_product.svg_groups.length > 0">
              <b-table
                  :items="factory_product.svg_groups"
                  :fields="svg_group_headers"
                  hover
                  sorter
              >
                <template #cell(url)="data">
                  <img :src="`${storage_url}/${data.item.url}`" alt="" width="100" >
                </template>
                <template #cell(size)="data">
                  <div>{{data.item.width}} X {{data.item.height}}</div>
                </template>
              </b-table>
            </template>
            <template v-else="">
              <cRow>
                <cCol class="col-12">
                  No Custom Logos Exists
                </cCol>
              </cRow>
            </template>
          </cCol>
          <cCol class="col-6 mt-2">

          </cCol>
        </cRow>

      </template>


    </modal>

    <modal :width="1000"
           :clickToClose="false"
           :resizable="true"
           :scrollable="true"
           height="auto"
           :reset="true"
           name="rejection-modal" ref="rejection-modal" id="modal-center-lockerroom" size="xl" :hide-footer="true"
           @close="$store.commit('Change_Locker_Active_Tab', 0)" @opened="showMarkerActionButtons">

      <div class="modal-header fs-4 d-flex justify-content-between p-3">
        <div class="font-weight-bold pl-1">
          Artwork Approval
          <span class="badge badge-dark font-weight-lighter" style="line-height: normal">
            {{activity_navigation_index+1}} / {{activity_items.activity_item_data.length}}
          </span>
        </div>
        <div class="d-flex justify-content-end" style="flex-grow: 8;">
          <button class="btn btn-secondary light mx-1" @click="$modal.hide('rejection-modal')">Cancel</button>
          <template v-if="activity_items.activity_item_data[activity_navigation_index] && activity_items.activity_item_data[activity_navigation_index].action">
            <span v-if="activity_items.activity_item_data[activity_navigation_index].action == 'accept'" class="mx-1">Accepted</span>
            <span v-else class="mx-1">Rejected</span>
          </template>
          <template v-else>
            <button class="btn btn-secondary mx-1" @click="approveRejectDesigns('accept')">Accept</button>
            <button class="btn btn-secondary mx-1" @click="approveRejectDesigns('reject')"
                    :disabled="(order && order.additional_fields && order.additional_fields.is_manual_order) ? true : false"
                    :title="(order && order.additional_fields && order.additional_fields.is_manual_order) ? 'Manual Order Can Not Be Rejected' : ''"
            >Reject
            </button>
          </template>
        </div>
        <span class="modal-close cursor-pointer" @click="$modal.hide('rejection-modal')">
          <BIconX />
        </span>
      </div>

      <template v-if="activity_items.activity_item_data[activity_navigation_index] && modalType == 'factory_review' ">

        <div class="d-flex align-items-center justify-content-between gap-1 py-4 px-3 m-auto">
          <div class="fs-5">
            <BIconChevronLeft @click="navigateActivitySlider('back')" />
          </div>

          <div v-for="(actFile, fileInd) in activity_items.activity_item_data[activity_navigation_index].files" :key="`actfile-${fileInd}`">
            <div :id="`markerAreaDiv${fileInd}${activity_navigation_index}`" :key="`markerAreaDiv${fileInd}${activity_navigation_index}`" ></div>
            <img @click="activity_items.activity_item_data[activity_navigation_index].action ? '' : showMarkerArea(fileInd)" :ref="`designImage${fileInd}${activity_navigation_index}`" :src="`${actFile.file}`" alt="" class="w-100"
                 :id="`image${fileInd}${activity_navigation_index}`" :key="`designImage${fileInd}${activity_navigation_index}`" crossorigin="anonymous">
          </div>

          <div class="fs-5" v-if="(activity_items.activity_item_data.length - 1) != activity_navigation_index">
            <BIconChevronRight @click="navigateActivitySlider('next')" />
          </div>
        </div>
        <div class="d-flex justify-content-center p-3">
          <button class="btn btn-secondary light mx-1" v-if="!batch_loading" @click.prevent="batchDownloadAssets(activity_items,activity_navigation_index)">Batch Assets Download</button>
          <button class="btn btn-dark mx-1" v-else>
            <span class="spinner-border"></span>
          </button>
        </div>

        <div class="p-4 text-left">
          <div class="fs-4">Write your feedback</div>
          <div class="mt-2">
            <b-textarea v-model="activity_items.activity_item_data[activity_navigation_index].message" placeholder="Please write your feedback here..." rows="5"></b-textarea>
          </div>
        </div>

        <div class="modal-footer">
          <button class="btn btn-ghost-dark light" @click="$modal.hide('rejection-modal')">Cancel</button>

          <template v-if="activity_items.activity_item_data[activity_navigation_index].action">
            <span v-if="activity_items.activity_item_data[activity_navigation_index].action == 'accept'">Accepted</span>
            <span v-else>Rejected</span>
          </template>
          <template v-else>
            <button class="btn btn-ghost-success light" @click="approveRejectDesigns('accept')">Accept</button>
            <button class="btn btn-ghost-danger light" @click="approveRejectDesigns('reject')"
                    :disabled="(order && order.additional_fields && order.additional_fields.is_manual_order) ? true : false"
                    :title="(order && order.additional_fields && order.additional_fields.is_manual_order) ? 'Manual Order Can Not Be Rejected' : ''">
              Reject
            </button>
          </template>

        </div>

      </template>



    </modal>


    <modal :width="1000"
           :clickToClose="false"
           :resizable="true"
           :scrollable="true"
           height="auto"
           :reset="true"
           name="test-sample-modal" ref="test-sample-modal" id="modal-center-lockerroom" size="xl" :hide-footer="true"
           @close="$store.commit('Change_Locker_Active_Tab', 0)">

      <div class="modal-header fs-4 d-flex justify-content-between p-3">
        <div class="font-weight-bold pl-1">
          Upload Sample File
        </div>

        <div class="d-flex justify-content-end" style="flex-grow: 8;">
          <button class="btn btn-secondary light mx-1" @click="$modal.hide('test-sample-modal')">Cancel</button>
          <template v-if="design_approval_activity_item_data.length">
            <button class="btn btn-secondary mx-1" @click="skipSampleApproval(design_approval_activity_item_data,design_approval_activity_navigation_index)">Skip Sample Approval</button>
            <div class="message_container position-absolute p-5" style="z-index: 9999" v-if="design_approval_activity_item_data[design_approval_activity_navigation_index].skip_customer_approval.show_reason_modal" :key="`design-approval-${design_approval_activity_navigation_index}`">
              <div class="d-flex flex-column message bg-light p-3 rounded-lg shadow-lg">
                <b-form-textarea rows="4" placeholder="Enter reason to skip" v-model="design_approval_activity_item_data[design_approval_activity_navigation_index].skip_customer_approval.reason">
                </b-form-textarea>
                <div class="d-flex justify-content-end pt-2" style="gap: 10px">
                  <b-button class="align-self-end" @click="closeMessage(design_approval_activity_item_data,design_approval_activity_navigation_index)">Cancel</b-button>
                  <b-button class="align-self-end" @click="updateReason(design_approval_activity_item_data,design_approval_activity_navigation_index)" variant="info">Save</b-button>
                </div>
              </div>
            </div>
          </template>
          <template v-if="design_approval_activity_navigation_index > 0">
            <button class="btn btn-dar mx-1" @click="navigateSampleFiles('back')">Previous</button>
          </template>
          <template v-if="((design_approval_activity_item_data.length - 1) == design_approval_activity_navigation_index)">
            <button class="btn btn-submit-sample mx-1"    
            :disabled="!validateSampleFiles()"                      
            @click="submitSampleFiles()">Submit Samples</button>
          </template>
          <template v-else>
            <template v-if="design_approval_activity_item_data.length">
              <button class="btn btn-dark mx-1"
              :disabled="!validateSampleFiles()" 
              @click="navigateSampleFiles('next')">Next</button>
            </template>
          </template>
        </div>

        <span class="modal-close cursor-pointer" @click="$modal.hide('test-sample-modal')">
              <BIconX />
            </span>
      </div>
     
      <template v-if="design_approval_activity_item_data[design_approval_activity_navigation_index] && modalType == 'test_sample'">
  <div class="d-flex flex-wrap gap-3 py-4 px-3 m-auto">
    <div
      v-for="(actFile, fileInd) in design_approval_activity_item_data[design_approval_activity_navigation_index].files"
      :key="`actfile-${fileInd}`"
      class="d-flex flex-column"
      style="width: 48%"  
    >
      <div class="fs-5 mb-2">
        <strong>{{ actFile.side.toUpperCase() }}</strong>
      </div>

      <!-- Upload Box -->
      <label class="upload-box position-relative w-100">
        <a class="remove" v-if="actFile.file" @click="deleteFile(design_approval_activity_navigation_index, fileInd)">
          <BIconX />
        </a>

        <template v-if="actFile.file">
          <div class="uploaded-logo-holder">
            <img
              :src="setSampleImage(design_approval_activity_navigation_index, fileInd)"
              class="img-fluid"
              style="width: 100%; max-width: 350px"
            />
          </div>
        </template>

        <input
  v-if="!actFile.file"
  type="file"
  @change.stop="changeSampleFile($event.target.files, design_approval_activity_navigation_index, fileInd)"
  class="mt-2"
/>
      </label>

      <!-- Rejected Image -->
      <div
        v-if="design_approval_activity_item_data[design_approval_activity_navigation_index].rejected_files.length === 2 && !actFile.file"
        class="mt-2"
      >
        <img
          :src="`${storage_url}/${design_approval_activity_item_data[design_approval_activity_navigation_index].rejected_files[fileInd]}`"
         
        />
        <span
          v-if="design_approval_activity_item_data[design_approval_activity_navigation_index].rejected_msg && fileInd === 0"
          class="text-danger mt-1 d-block"
        >
          {{ design_approval_activity_item_data[design_approval_activity_navigation_index].rejected_msg }}
        </span>
      </div>

      <!-- Product File Preview -->
      <div
        v-if="design_approval_activity_item_data[design_approval_activity_navigation_index].product_files[fileInd]"
        class="upload-box mt-2"
      >
        <div class="uploaded-logo-holder">
          <img
            :src="`${storage_url}/${design_approval_activity_item_data[design_approval_activity_navigation_index].product_files[fileInd]}`"
            class="img-fluid"
            
          />
        </div>
      </div>
    </div>

    <!-- Message if both files are missing -->
    <template v-if="!hasValidProductFiles(design_approval_activity_item_data[design_approval_activity_navigation_index].product_files)">
      <div class="w-100 text-center py-4">
        No sample files exist due to manual creation.
      </div>
    </template>
  </div>
</template>


  <div class="modal-footer">
    <button class="btn btn-secondary light" @click="$modal.hide('test-sample-modal')">Cancel</button>
    <template v-if="design_approval_activity_navigation_index > 0">
      <button class="btn btn-dark" @click="navigateSampleFiles('back')">Previous</button>
    </template>
    <template v-if="((design_approval_activity_item_data.length - 1) == design_approval_activity_navigation_index)">
      <button class="btn btn-submit-sample"    
      :disabled="!validateSampleFiles()"   
      @click="submitSampleFiles()">Submit Samples</button>
    </template>
    <template v-else>
      <template v-if="design_approval_activity_item_data.length">
        <button class="btn btn-dark" :disabled="!validateSampleFiles()" @click="navigateSampleFiles('next')">Next</button>
      </template>
    </template>
  </div>


    </modal>

    <modal :adaptive="true"
           :clickToClose="false"
           height="auto"
           :minWidth="1300"
           :scrollable="true"
           name="product-preview" ref="product-preview" :hide-footer="true">

      <div class="modal-header fs-4 d-flex justify-content-between p-3">
        <div class="font-weight-bold pl-1">
          Preview Images
        </div>

        <span class="modal-close cursor-pointer" @click="$modal.hide('product-preview')">
              <BIconX />
            </span>
      </div>

      <div class="px-3 pt-3 d-flex justify-content-center">
        <div class="badge badge-light fs-2 p-2 text-muted"> <b-icon-search class="text-info"></b-icon-search> Please hover over the images to zoom!</div>
      </div>
      <div class="d-flex w-100 justify-content-center gap-1 py-4 px-3">
        <zoom-on-hover :img-normal="this.storage_url+'/'+this.front_preview" :img-zoom="this.storage_url+'/'+this.front_preview" :scale="2"></zoom-on-hover>
        <zoom-on-hover :img-normal="this.storage_url+'/'+this.back_preview" :img-zoom="this.storage_url+'/'+this.back_preview" :scale="2"></zoom-on-hover>
      </div>

      <div class="px-3 pb-3 d-flex justify-content-center">
        <button class="btn btn-dark text-white" v-if="!loadingPreviewImages"  :disabled="!hasPreviewImages" @click="downloadImages">Download Preview Images</button>
        <button class="btn btn-dark text-white" v-else disabled><b-icon-arrow-counterclockwise class="b-icon-animation-spin-reverse" /> Please wait...</button>
      </div>
    </modal>


    <modal :width="600"
           :clickToClose="false"
           :resizable="true"
           :scrollable="true"
           height="auto"
           :reset="true"
           name="production-files-modal" ref="production-files-modal" id="production-files-modal" size="xl" :hide-footer="true"
    >

      <div class="modal-header fs-4 d-flex justify-content-between p-3">
        <div class="font-weight-bold pl-1">
          Upload Production Files
        </div>

        <div class="d-flex justify-content-end" style="flex-grow: 8;">
          <button class="btn btn-secondary light mx-1" @click="$modal.hide('production-files-modal')">Cancel</button>
          <template v-if="activity_navigation_index > 0">
            <button class="btn btn-dark mx-1" @click="navigateSampleFiles('back')">Previous</button>
          </template>
          <template v-if="((activity_items.activity_item_data.length - 1) == activity_navigation_index)">
            <button class="btn btn-secondary mx-1" @click="submitSampleFiles()">Upload Files</button>
          </template>
          <template v-else>
            <button class="btn btn-dark mx-1" @click="navigateSampleFiles('next')">Next</button>
          </template>
        </div>

        <span class="modal-close cursor-pointer" @click="$modal.hide('production-files-modal')">
              <BIconX />
            </span>
      </div>

      <template v-if="activity_items.activity_item_data[activity_navigation_index] && modalType == 'production_sample'">

        <div class="d-flex justify-content-between gap-2 py-4 px-3 m-auto">


          <div style="width: 100%" v-for="(actFile, fileInd) in activity_items.activity_item_data[activity_navigation_index].files" :key="`actfile-${fileInd}`">
            <div class="fs-2"><strong>{{actFile.side.toUpperCase()}}</strong></div>

            <label class="upload-box position-relative">
              <a class="remove" v-if="actFile.file" @click="deleteFile(activity_navigation_index, fileInd)">
                <BIconX/>
              </a>
              <template v-if="actFile.file">

                <template v-if="['jpg', 'jpeg', 'png','bmp', 'svg'].includes(getProductionFileExtention(activity_navigation_index, fileInd))">
                  <div class="uploaded-logo-holder">
                    <img :src="setSampleImage(activity_navigation_index, fileInd)"  style="width: 100%; max-width: 350px"/>
                  </div>
                </template>
                <template v-else>
                  <button class="btn btn-secondary" style="width:100%;height:100%">
                    <b-icon-file-earmark style="width:100%;height:100%"/>
                  </button>
                </template>

              </template>
              <input v-if="!actFile.file" type="file" @change="changeSampleFile($event.target.files, activity_navigation_index, fileInd)"  placeholder="upload sample file"  style="margin-top: 5px;z-index:1"/>
            </label>

            <div class="upload-box mt-1">
              <div class="uploaded-logo-holder">
                <img :src="`${storage_url}/${activity_items.activity_item_data[activity_navigation_index].product_files[fileInd]}`" />
              </div>
            </div>

          </div>

        </div>

        <div class="modal-footer">
          <button class="btn btn-secondary light" @click="$modal.hide('production-files-modal')">Cancel</button>
          <template v-if="activity_navigation_index > 0">
            <button class="btn btn-dark" @click="navigateSampleFiles('back')">Previous</button>
          </template>
          <template v-if="((activity_items.activity_item_data.length - 1) == activity_navigation_index)">
            <button class="btn btn-secondary" @click="submitSampleFiles()">Upload Files</button>
          </template>
          <template v-else>
            <button class="btn btn-dark" @click="navigateSampleFiles('next')">Next</button>
          </template>

        </div>

      </template>

    </modal>





    <b-modal no-close-on-backdrop hide-footer ref="quoteAcceptModal"  id="modal-1" :title="`Provide Quote`">
      <CRow>

        <CCol class="col-12">
          <label class="required">Provide Quote</label>
          <b-form-textarea v-validate="{required: true, min: 3}" id="textarea" v-model="quote.quote_text" placeholder="Enter quote text" rows="2"
          ></b-form-textarea>
          <b-button @click="saveQuotePrice" class="mt-2 float-right" variant="primary">Save</b-button>
        </CCol>
      </CRow>
    </b-modal>
    <QuoteModal v-if="order" ref="quoteModal" @call-order-detail="getOrderDetail" :order="order"/>

  </div>
</template>

<script>
import ActivityStatusIcons from "@/components/ActivityStatusIcons";
import AddUpdateComment from "@/components/AddUpdateComment.vue";
import OrderFlowStatusLine from "@/components/OrderFlowStatusLine";
import ProductionFileGenerator from "@/components/ProductionFileGenerator";
import QuoteModal from "@/components/QuoteModal";
import { http } from "@/config/httpCommon";
import * as markerjs2 from 'markerjs2';
import moment from "moment";
import Vue from 'vue';

import {
  activityStatus,
  base64ToFile,
  fileToBase64,
  findActivity,
  findActivityWithPosition,
  getBlobFromString,
  getDomDocument,
  getFileExtensionType,
  handleResponseException,
  isBase64File,
  logData,
  mergeActivityArray,
  showToast,
  urlToBase64,
  urlToBase64Backend,
  setPageTitle
} from "@/helpers/Helpers";
import { formatTimestampWithBrowserTimezone } from '@/helpers/useTimeZoneFormatDate';
import $ from 'jquery';
import { filter, findIndex } from "lodash";
import FileView from './FileView.vue';

// -------- Order Status Constants
const QUOTEREQUESTED = "quote_requested"
const QUOTEUPDATED = "quote_updated"
const QUOTEPROVIDED = "quote_provided"
const QUOTEREJECTED = "quote_rejected"
const FACTORYREVIEW = "submitted_for_factory_review"
const ORDERAPPROVE = "order_approve"
const ORDERCANCEL = "order_cancel"
const FACTORYAPPROVED = "factory_approved"
const FACTORYREJECTED = "factory_rejected"
const CUSTOMERREVIEW = "submitted_for_customer_review"
const CUSTOMERAPPROVED = "customer_approved"
const CUSTOMERREJECTED = "customer_rejected"
const ORDERINPRODUCTION = "in_production"
const QUALITYCONTROL = "quality_control"
const ORDERSHIPPED = "shipped"
const ORDERCOMPLETED = "completed"
const FACTORY_APPROVE_REJECT = "factory_approve_reject"
const PRODUCTIONFILESUPLOADED = "production_files_uploaded"



export default {
  name: "order-detail",
  components: {
    AddUpdateComment,
    OrderFlowStatusLine,
    ActivityStatusIcons,
    ProductionFileGenerator,
    QuoteModal,
    FileView
  },
  props: {
    p_order_id: {
      type: String,
      default:null
    }
  },
  data () {
    return {
      measurement_unit:{
        unit:"cm",
      },
      approvalEmail: '',
      loadingPreviewImages : false,
      activityStatus: activityStatus,
      QUOTEREQUESTED : QUOTEREQUESTED,
      QUOTEUPDATED : QUOTEUPDATED,
      QUOTEPROVIDED : QUOTEPROVIDED,
      QUOTEREJECTED : QUOTEREJECTED,
      FACTORYREVIEW : FACTORYREVIEW,
      ORDERAPPROVE : ORDERAPPROVE,
      ORDERCANCEL : ORDERCANCEL,
      FACTORYAPPROVED : FACTORYAPPROVED,
      FACTORYREJECTED : FACTORYREJECTED,
      CUSTOMERREVIEW : CUSTOMERREVIEW,
      CUSTOMERAPPROVED : CUSTOMERAPPROVED,
      CUSTOMERREJECTED : CUSTOMERREJECTED,
      PRODUCTIONFILESUPLOADED : PRODUCTIONFILESUPLOADED,
      ORDERINPRODUCTION : ORDERINPRODUCTION,
      QUALITYCONTROL : QUALITYCONTROL,
      ORDERSHIPPED : ORDERSHIPPED,
      ORDERCOMPLETED : ORDERCOMPLETED,
      INCH_TO_CENTIMETER:2.54,
      moveOrderOptions : [
        { value: null, text: 'Please select an option' },
        { value: FACTORYREVIEW , text: 'Order Created' },
        { value: ORDERAPPROVE , text: 'Mark to factory' },
        { value: ORDERCANCEL , text: 'Order Cancelled' },
        { value: FACTORYAPPROVED, text: 'Artwork Approval' },
        { value: FACTORY_APPROVE_REJECT, text: 'Artwork Approval/Artwork Rejected' },
        { value: CUSTOMERREVIEW, text: 'Customer Review' },
        { value: ORDERINPRODUCTION, text: 'In Production' },
        { value: ORDERSHIPPED, text: 'Order Shipped' },
        { value: ORDERCOMPLETED, text: 'Order Completed' },

      ],
      move_order_to_status:null,
      move_order_reason: null,
      loading:false,
      selected_attachment:[],
      factory_product:{},
      active_order_item_id: null,
      roster_detail:[],
      svg_pattern_last_value_y:5000,
      logo_pattern_last_value_y:0,
      font_file:[],
      production_content:"",
      production_file_info: {
      },
      roster_headers: [
        {key: 'size', label: 'Size'}, {key: 'download', label: 'Download'}, {key: 'quantity', label: 'Quantity'}, {key: 'number', label: 'Number'}, {key: 'text', label: 'Text'}
        // {key: 'size', label: 'Size'}, {key: 'quantity', label: 'Quantity'}, {key: 'number', label: 'Number'}, {key: 'name', label: 'Name'}
      ],
      custom_text_headers: [
        {key: 'label', label: 'Label'}, {key: 'placement', label: 'Placement'}, {key: 'color_pantone', label: 'Pantone'}, {key: 'font_family', label: 'Font Famliy'}
      ],
      custom_logos_headers: [
        {key: 'url', label: 'Logo'}, {key: 'side', label: 'Side'}, {key: 'size', label: 'Size'},{key: 'download', label: 'Download'}
      ],
      svg_group_headers: [
        {key: 'id', label: 'Group'}, {key: 'pantone', label: 'Pantone'}, {key: 'name', label: 'Pantone name'}
      ],

      storage_url : process.env.VUE_APP_FILE_URL,
      hey : process.env.VUE_APP_FILE_URLsss,
      order_id: null,
      order:null,
      logData: logData,
      activity_design_files:[],
      activity_navigation_index:null,
      activity_items:{
        order_move:0,
        order_item_id:null,
        order_item_index:null,
        order_item_status:null,
        tracking_link:null,
        tracking_no:'',
        shipping_company:null,
        reason:null,
        activity_item_data: []
      },
      design_approval_activity_item_data:[],
      design_approval_activity_navigation_index:null,
      entershipping:false,
      enterShippingDates: false,
      isPutInProduction: false,
      est_shipping_date: '',
      shipping_dates: [],
      shipping_companies:null,
      markerActive:false,
      modalType:null,
      isWebComponent: false,
      is_authenticated: this.$store.getters.isAuthenticated,
      company: this.$store.getters.company,
      api_url: process.env.VUE_APP_BASE_URL,
      no_custimo_order:false,
      product_texts:[],
      product_numbers:[],
      roster_details:[],
      logo_selected_id: null,
      custom_logos:[],
      batch_loading:false,
      front_preview:false,
      back_preview:false,
      quote : {
        quote_text :'',
        quote_order_id:'',
        quote_order_no:''
      },
      is_quote_order:false,
      show_quote_buttons:false,
      show_provide_quote_button:false,
      comment_action_taken: false,
      order_factories: [],
      order_item_id: null,
      start_download_production_file: false,
      size_download: '',
    }
  },

  filters: {
    initials(value) {
      let value_array = value.split(" ");

      // Select the first letter of the name
      let first_letter = value.charAt(0);
      let last_letter = "";
      if(value_array.length > 1) {
        last_letter = value_array[value_array.length - 1].charAt(0);
      }
      let initial_letters = first_letter + last_letter;
      // Return the initials
      return initial_letters? initial_letters.toUpperCase() : null;
    },
    formatDate(value, format) {
      if (!format) {
        format = "MM-DD-YYYY"
      }
      return moment(value).format(format)
    }
  },
  async mounted() {
    let self = this;
    self.isWebComponent = self.$root.$options.name == 'shadow-root';
    self.order_id = self.p_order_id || self.$route.params.order_id;
    await self.getOrderDetail();
    await self.getShippingCompanies();
    await self.getMeasurementUnit(self.order_id);
    if(this.$can('upload-production-files-activity')) {
      this.moveOrderOptions.push({ value: PRODUCTIONFILESUPLOADED, text: 'Upload production files' });
    }
  },
  computed: {
    getShippingOptions(){
      let shippingOptions = [];
      shippingOptions.push({ value: null, text: 'Select shipping company' })
      if(this.shipping_companies){
        for(let shipping in this.shipping_companies){
          shippingOptions.push({ value: shipping, text: this.shipping_companies[shipping].name })
        }
      }
      return shippingOptions;
    },
    role: function() {
      return this.$store.getters.userRole;
    },
    hasPreviewImages() {
    let urls = [];

    urls.push(this.front_preview);

      if (this.back_preview && this.back_preview !== "null" && this.back_preview !== null) {
        urls.push(this.back_preview);
      }

    // Keep only valid ones
    urls = urls.filter(u => u && u !== "null");

    return urls.length > 0; // true if we have at least one valid url
  }
  },
  methods: {
    linkifyText(text) {
       const urlRegex = /((https?:\/\/)?(www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\/\S*)?)/gi;

      return text.replace(urlRegex, (match) => {
        let url = match;

        // If URL has no protocol, add https://
        if (!/^https?:\/\//i.test(url)) {
          url = "https://" + url;
        }

        return `<a href="${url}" target="_blank" rel="noopener noreferrer">${match}</a>`;
      });
    },

    formatedDate(date) {
      return formatTimestampWithBrowserTimezone(date);
    },
    getFileExtensionType,
    hasValidProductFiles(productFiles) {
    // Check if productFiles is an array and has at least one non-null/undefined/empty string value
    return Array.isArray(productFiles) && productFiles.some(file => file);
  },

    getFileExtension(url) {
      if(url) {
        return url.split('.').pop().toLowerCase(); // Get the extension and convert to lowercase
      }
      return '';
    },
    reversedEstShippingDates(order_item) {
      return order_item.est_shipping_date ? [...order_item.est_shipping_date].reverse() : [];
    },
    showThirdPartyApprovalModal(order_item) {
      console.log("showThirdPartyApprovalModal", order_item);
    this.order_item_id = order_item.id;
    this.$modal.show("third-party-approval-modal");
    },
    getOrderDetail() {
      let self = this;
      let url = `customer-orders/${self.order_id}`
      http.get(url)
          .then((successResponse) => {
            let response_data = successResponse.data;
            self.order = response_data.result;
            setPageTitle(`#${self.order.order_no}`);
            self.is_quote_order = self.order.is_quote_order;
            self.order.items.forEach(order_item => {
              if (order_item.factory_id) {
                let exisitingFactory = this.order_factories.find(x => x.id == order_item.factory_id);
                if(!exisitingFactory){
                  this.order_factories.push({ id: order_item.factory_id, name: order_item.factory_name})
                } 
              }
              order_item.factory_products.forEach(factory_product => {
                factory_product.custom_logos.forEach(custom_logo => {
                  if (!("original_logo" in custom_logo)) {
                    custom_logo.original_logo = custom_logo.original_logo_url
                  }
                })
              })
            })

            if (self.is_quote_order) {
              const lastorderitem = self.order.items.at(-1);
              if(lastorderitem.status == 'quote_requested') {
                if(self.order.admin_salesrep_id) {
                  self.show_quote_buttons = true;

                  setTimeout( () => {
                    if(self.$route.query.accept_quote) {
                      this.acceptQuote();
                    }
                    if(self.$route.query.reject_quote) {
                      this.rejectQuote();
                    }
                  },100)

                } else {
                  self.show_provide_quote_button = true;
                }
              }
              if (lastorderitem.status == 'quote_provided') {
                self.show_quote_buttons = true;
              }
            }

            if (self.isWebComponent)
              self.no_custimo_order = (!response_data.success) ? true : false;
          }).catch((errorResponse) => {
        console.log(errorResponse)
        handleResponseException(errorResponse)
      });
    },
    getMeasurementUnit(order_id) {
      let url = `get-configuration/${order_id}/measurement_unit`;
      http.get(url)
          .then((successResponse) => {
            this.measurement_unit = successResponse.data.result;
          }).catch((errorResponse) => {
        console.log(errorResponse)
        handleResponseException(errorResponse)
      });
    },
    getShippingCompanies() {
      let self = this;
      let url = `get-shipping-companies`
      http.get(url)
          .then((resp) => {
            this.shipping_companies = resp.data
          }).catch((errorResponse) => {
        console.log(errorResponse)

      });
    },
    setTrackingLink(e, type) {

      let company = null;
      if (type == 'company') {
        company = e;
      } else if (type == 'number') {
        company = this.activity_items.shipping_company
      }

      if (this.shipping_companies[company]) {
        let track_link = this.shipping_companies[company].tracking_link;
        track_link = track_link.replace('{tracking_no}', this.activity_items.tracking_no)
        this.activity_items.tracking_link = track_link
      } else {
        this.activity_items.tracking_link = ''
      }
    },
    async deleteComment(activity_comment, item_status_activity) {
      let url = `order_item/${activity_comment.id}/delete_comment`;
      let comment_index = item_status_activity.comments.indexOf(activity_comment);
      item_status_activity.comments.splice(comment_index, 1);
      http.delete(url)
          .then((successResponse) => {
            let response = successResponse.data;
          }).catch((errorResponse) => {
        item_status_activity.comments.push(activity_comment);
        handleResponseException(errorResponse)
      });
    },

    async takeCommentAction(activity_comment) {
      this.$store.commit('set', ['showLoader', true]);
      let url = `order_item/comment/${activity_comment.id}/take_action`;
      await http.put(url, {
        action_taken: activity_comment.action_taken
      }).then((successResponse) => {
        let response = successResponse.data;
        activity_comment.action_taken_by = response.result.comment.action_taken_by;
        activity_comment.action_taken_at = response.result.comment.action_taken_at;
        this.$store.commit('set', ['showLoader', false]);
      }).catch((errorResponse) => {
        this.$store.commit('set', ['showLoader', false]);
        activity_comment.action_taken = !activity_comment.action_taken;
        handleResponseException(errorResponse);
      });
    },

    hideCommentBox(hide_comment_box_for_obj, obj_key) {
      this.$set(hide_comment_box_for_obj, obj_key, false);
    },

    handleCommentActionCompleted(event_data, activity_item, activity_item_comment_index) {
      let self = this;
      self.$set(activity_item.comments, activity_item_comment_index, event_data)
    },

    /*
    * Item activity methods starts
    * */

    showArtworkDesigns(order_item, order_item_index, status_activity_index) {

      this.modalType = 'factory_review';
      this.activity_items.order_item_id = order_item.id
      this.activity_items.order_item_index = order_item_index

      let activity_item = Object.assign({}, order_item.status_activities[status_activity_index]);


      this.activity_items.activity_item_data = [];
      for (let actItem of activity_item.activity_items) {
        let actObj = {};
        actObj.action = null;
        actObj.status = activity_item.status;
        actObj.message = null;
        actObj.files = [];
        actObj.factory_product_id = actItem.factory_product_id;
          if(actItem.activity_files != undefined && actItem.activity_files.length > 0) {        
            for (let actfile of actItem.activity_files) {
              if(actfile.url) {
                let fileObj = {};
                fileObj.file = `${this.storage_url}/${actfile.url}?nocache=${Math.random()}`;
                fileObj.file_type = null;
                actObj.files.push(fileObj);
              }
          }
        } else {          
          if(actItem.product_info && actItem.product_info.front_image && actItem.product_info.back_image){            
            let front_fileObj = {};
            front_fileObj.file = `${this.storage_url}/${actItem.product_info.front_image}?nocache=${Math.random()}`;
            front_fileObj.file_type = null;
            actObj.files.push(front_fileObj);

            let back_fileObj = {};
            back_fileObj.file = `${this.storage_url}/${actItem.product_info.back_image}?nocache=${Math.random()}`;            
            back_fileObj.file_type = null;
            actObj.files.push(back_fileObj);
          }         
        }
        
        this.design_approval_activity_item_data = [];

        let factory_product = order_item.factory_products.find(factory_product => factory_product.id === actItem.factory_product_id);
        let skipCustomerApproval = {
          design_customer_approval: true,
          reason: null,
          show_reason_modal: false,
          username: this.auth_user?.name,
          user_id: this.auth_user?.id,
          role_name: this.auth_user?.role?.name
        }
        if (factory_product?.sku?.design_customer_approval !== undefined) {
          skipCustomerApproval.design_customer_approval = !!factory_product.sku.design_customer_approval;
          skipCustomerApproval.reason = null;
          skipCustomerApproval.show_reason_modal = false;
          skipCustomerApproval.username = this.auth_user?.name;
          skipCustomerApproval.user_id = this.auth_user?.id;
          skipCustomerApproval.role_name = this.auth_user?.role?.name;
        }
        actObj.skip_customer_approval = skipCustomerApproval;

        this.activity_items.activity_item_data.push(actObj);
        if (factory_product?.sku?.design_customer_approval !== undefined) {
          if (actObj.skip_customer_approval.design_customer_approval) {
            this.design_approval_activity_item_data.push(actObj)
          }
        } else {
          this.design_approval_activity_item_data.push(actObj);
        }
        this.$modal.show('rejection-modal');
        if (this.activity_items.activity_item_data.length > 0) {
          this.activity_navigation_index = 0;
          this.design_approval_activity_navigation_index = 0;
        }
      }
    },
    submitActivity(submit_type) {
      this.$store.commit('set', ['showLoader', true]);
      this.activity_items.activity_item_data.skip_customer_approval = JSON.stringify(this.activity_items.activity_item_data.skip_customer_approval);
      let form_data = this.activity_items;
      form_data['order_id'] = this.order_id;
      form_data['manual_activity'] = true; 
      if (submit_type == 'form_data') {
        // form_data = null;
        form_data = new FormData();
        form_data.append('order_id', this.order_id);

        for (const key in this.activity_items) {
          if (key == 'activity_item_data') {
            this.activity_items[key].forEach((activity_file_obj, actIndx) => {
              for (const key2 in activity_file_obj) {
                if (key2 == 'files') {
                  activity_file_obj[key2].forEach((activity_file, fileInd) => {
                    for (const key3 in activity_file) {
                      if(key3 === "file"){
                        if(this.activity_items[key][actIndx][key2][fileInd][key3] && isBase64File(this.activity_items[key][actIndx][key2][fileInd][key3])){
                          form_data.append(key+'['+actIndx+']['+key2+']['+fileInd+']['+key3+']', base64ToFile(this.activity_items[key][actIndx][key2][fileInd][key3], true));
                        }
                        else {
                          form_data.append(key+'['+actIndx+']['+key2+']['+fileInd+']['+key3+']', this.activity_items[key][actIndx][key2][fileInd][key3]);
                        }
                      }
                      if(key3 === "file_type"){
                        if(this.activity_items[key][actIndx][key2][fileInd][key3] == "encode"){
                          form_data.append(key+'['+actIndx+']['+key2+']['+fileInd+']['+key3+']', "object");
                        }
                        else {
                          form_data.append(key+'['+actIndx+']['+key2+']['+fileInd+']['+key3+']', this.activity_items[key][actIndx][key2][fileInd][key3]);
                        }
                      }
                    }
                  });
                } else if (key2 == 'skip_customer_approval') {
                  Object.entries(activity_file_obj[key2]).forEach(([skipkey, skip_value]) => {
                    form_data.append(key + '[' + actIndx + '][' + key2 + '][' + skipkey + ']', this.activity_items[key][actIndx][key2][skipkey]);
                  })
                } else {

                  form_data.append(key + '[' + actIndx + '][' + key2 + ']', this.activity_items[key][actIndx][key2]);
                }
              }
            });
          } else {
            form_data.append(key, this.activity_items[key]);
          }

        }
      }

      let url = `customer-orders/${this.activity_items.order_item_id}/order-activity`

      http.post(url, form_data)
          .then(async (successResponse) => {
            let response_data = successResponse.data;
            this.resetActivity(response_data);

          }).catch((errorResponse) => {
        this.$store.commit('set', ['showLoader', false]);
        handleResponseException(errorResponse)
      });
    },
    async resetActivity(response_data) {
      await this.getOrderDetail();
      Vue.set(this.order.items, this.activity_items.order_item_index, response_data.result.order_item)
      this.$modal.hide('rejection-modal');
      this.$modal.hide('test-sample-modal');
      this.$modal.hide('production-files-modal');
      this.modalType = null;

      this.$store.commit('set', ['showLoader', false]);
      this.resetActivityData();
    },
    resetActivityData(){
      this.move_order_to_status = null
      this.move_order_reason = null
      this.activity_items.order_move = 0
      this.activity_items.order_item_id = null
      this.activity_items.order_item_index = null
      this.activity_items.tracking_link = null,
          this.activity_items.tracking_no = '',
          this.activity_items.shipping_company = null,
          this.activity_items.activity_item_data = []
      this.activity_navigation_index = null
      this.activity_items.order_item_status = null
      this.activity_items.reason = null
    },

  showMarkerArea(ref_index) {
    this.markerActive = true
    let activityObj = this.activity_items.activity_item_data[this.activity_navigation_index];
    if(this.$refs['designImage' + ref_index + this.activity_navigation_index]) {
      let image = this.$refs['designImage' + ref_index + this.activity_navigation_index][0];
      const markerArea = new markerjs2.MarkerArea(image)
      activityObj.files[ref_index].marker_ref = markerArea
      markerArea.addEventListener('render', event => {
        activityObj.files[ref_index].file = event.dataUrl
        activityObj.files[ref_index].file_type = 'encode'
      });
      if (this.$root.$options.name == 'shadow-root') {
        let shadow_dom = this.$root.$options.shadowRoot;
        markerArea.targetRoot = shadow_dom.getElementById('markerAreaDiv' + ref_index + this.activity_navigation_index);
        markerjs2.Style.styleSheetRoot = shadow_dom;
      } else {
        markerArea.targetRoot = document.getElementById('markerAreaDiv' + ref_index + this.activity_navigation_index);
      }

      markerArea.renderAtNaturalSize = true;
      markerArea.show();
    }
  },

  navigateActivitySlider(direction) {

    let activityObj = this.activity_items.activity_item_data[this.activity_navigation_index];

    if (direction == 'next') {
      if (activityObj.action == null) {
        this.showToast('Please accept or reject designs before navigate');
      } else {
        let limit = this.activity_items.activity_item_data.length;
        if ((this.activity_navigation_index + 1) < limit) {
          this.activity_navigation_index++
        }
        if (
            (this.activity_items.activity_item_data.length - 1) == this.activity_navigation_index
            && this.activity_items.activity_item_data[this.activity_navigation_index].action) {
          this.submitActivity('form_data')
        }
        this.showMarkerActionButtons()
      }
    } else {
      if ((this.activity_navigation_index - 1) >= 0) {
        this.activity_navigation_index--
      }
    }
  },

  async approveRejectDesigns(action) {
    let imageEdit = false
    if (this.markerActive) {
      imageEdit = true
      $(".modal-header").next(".d-flex").children("div:not(.fs-5)").each(function () {
        $(this).find(".__markerjs2_toolbar-block:eq(2) .__markerjs2_toolbar_button_colors:eq(0)").trigger("click")
      })
    }

    this.markerActive = false
    setTimeout(() => {
      let activityObj = this.activity_items.activity_item_data[this.activity_navigation_index];
      let show_message = false;
      if (action === 'reject') {
        if ((activityObj.message == null || activityObj.message === '') && !imageEdit) {
          show_message = true;
          this.showToast('Please provide feedback or edit image before rejection');
        }
      }
      if (show_message === false) {
        this.renderMarkerJsImages().then(marker_js_base64_images => {
          marker_js_base64_images.forEach((marker_js_base64_image_item, marker_js_base64_image_index) => {
            this.activity_items.activity_item_data[this.activity_navigation_index].files[marker_js_base64_image_index].file = marker_js_base64_image_item;
            this.activity_items.activity_item_data[this.activity_navigation_index].files[marker_js_base64_image_index].file_type = 'encode'
          })
          this.activity_items.activity_item_data[this.activity_navigation_index].action = action;
          if (action === "reject") {
            this.activity_items.activity_item_data[this.activity_navigation_index].status = this.FACTORYREJECTED;
          } else {
            this.activity_items.activity_item_data[this.activity_navigation_index].status = this.FACTORYAPPROVED;
          }
          this.navigateActivitySlider('next')
        })
      }
    }, 1000)
  },
  renderMarkerJsImages() {
    let marker_js_render_events = [];
    this.activity_items.activity_item_data[this.activity_navigation_index].files.forEach(marker_js_item => {
      marker_js_render_events.push(marker_js_item.marker_ref.render())
      delete marker_js_item.marker_ref
    })
    return Promise.all(marker_js_render_events)
  },
  uploadSampleFiles(order_item, order_item_index, status_activity_index) {
    this.activity_items.order_item_id = order_item.id
    this.activity_items.order_item_index = order_item_index
    this.activity_items.activity_item_data = [];
    this.design_approval_activity_item_data = [];
    let activity_item = Object.assign({}, order_item.status_activities[status_activity_index]);
    let actItem = order_item.status_activities.find( (status_activity) => status_activity.status ===  this.CUSTOMERREVIEW);

    for(let factProd of order_item.factory_products){
      if(factProd.status !== this.CUSTOMERAPPROVED){
        const product_images = [factProd.front_image]
        if(factProd.back_image) {
          product_images.push(factProd.back_image)
        }
            let actObj = {};
            actObj.action = null;
            actObj.status = this.CUSTOMERREVIEW;
            actObj.message = '';
            actObj.files = [];
            actObj.factory_product_id = factProd.id;
            actObj.product_files = product_images;
            actObj.rejected_files = [];
            actObj.rejected_msg = '';

            if (activity_item.status == this.CUSTOMERREJECTED) {
              activity_item.activity_items.forEach(fileObj => {
                if (fileObj.factory_product_id == factProd.id) {
                  actObj.rejected_files = [fileObj.activity_files[0].url, fileObj.activity_files[1].url]
                  actObj.rejected_msg = fileObj.message
                }
              })
            }

            let skipCustomerApproval =  {
              design_customer_approval: true,
              reason: null,
              show_reason_modal: false,
              username : this.auth_user?.name,
              user_id : this.auth_user?.id,
              role_name : this.auth_user?.role?.name,
            };
            if(activity_item.status === this.CUSTOMERREJECTED)
            {
              let all_activity_Items = null
              let status_to_check = this.FACTORYREVIEW;
              if(this.order && this.order.ecommerce_order_id){
                  status_to_check = this.ORDERAPPROVE;
              }

              let artwork_created_activity = findActivityWithPosition(order_item?.status_activities, status_to_check, 0)
              let submitted_customer_review_activity = findActivity(order_item?.status_activities, this.CUSTOMERREVIEW, artwork_created_activity?.activity_items.length)

              if(submitted_customer_review_activity){
                all_activity_Items = mergeActivityArray(activity_item.activity_items, artwork_created_activity.activity_items, submitted_customer_review_activity);
              }

              let activityItem = all_activity_Items.find(activity_item => {
                return activity_item.factory_product_id === factProd.id
              });

              if (activityItem) {
                skipCustomerApproval.design_customer_approval = (activityItem?.skip_customer_approval?.design_customer_approval === "true" || activityItem?.skip_customer_approval?.design_customer_approval === true || activityItem?.skip_customer_approval?.design_customer_approval === 1 )? true: false;
                skipCustomerApproval.reason = null;
                skipCustomerApproval.show_reason_modal = false;
                skipCustomerApproval.username = this.auth_user?.name;
                skipCustomerApproval.user_id = this.auth_user?.id;
                skipCustomerApproval.role_name = this.auth_user?.role?.name;
                if (activity_item.status === this.CUSTOMERREJECTED) {
                  actItem.activity_items.forEach(fileObj => {
                    if (fileObj.factory_product_id == factProd.id) {
                      actObj.rejected_files = [fileObj.activity_files[0].url, fileObj.activity_files[1].url]
                    }
                  })
                }
              }
            }
            else {
              if (factProd?.sku?.design_customer_approval !== undefined) {
                skipCustomerApproval.design_customer_approval = !!factProd.sku.design_customer_approval;
                skipCustomerApproval.reason = null;
                skipCustomerApproval.show_reason_modal = false;
                skipCustomerApproval.username = this.auth_user?.name;
                skipCustomerApproval.user_id = this.auth_user?.id;
                skipCustomerApproval.role_name = this.auth_user?.role?.name;

              }
            }
            actObj.skip_customer_approval = skipCustomerApproval;
            let fileObj = {};
            fileObj.file = null;
            fileObj.file_type = 'object';
            fileObj.side = 'front'
            actObj.files.push(fileObj);

            let fileObj2 = {...fileObj}
            fileObj2.side = 'back'
            actObj.files.push(fileObj2);

            this.activity_items.activity_item_data.push(actObj);
            if (factProd?.sku?.design_customer_approval !== undefined) {
              if (actObj && actObj?.skip_customer_approval?.design_customer_approval === "true" || actObj?.skip_customer_approval?.design_customer_approval === true) {
                this.design_approval_activity_item_data.push(actObj)
              }
            } else {
              this.design_approval_activity_item_data.push(actObj);
            }
          }
        }
        if (this.activity_items.activity_item_data.length > 0) {
          this.activity_navigation_index = 0;
          this.design_approval_activity_navigation_index = 0;
        }
        this.$modal.show('test-sample-modal');
        this.modalType = 'test_sample';

      },
      uploadProductionFiles(order_item, order_item_index){

        this.activity_items.order_item_id = order_item.id
        this.activity_items.order_item_index = order_item_index
        this.activity_items.reason = this.move_order_reason == null ? "" : this.move_order_reason;
        this.activity_items.order_item_status = this.PRODUCTIONFILESUPLOADED;
        this.activity_items.activity_item_data = [];


        for(let factProd of order_item.factory_products){
          let actObj = {};
          actObj.action = null;
          actObj.status = this.PRODUCTIONFILESUPLOADED;
          actObj.message = '';
          actObj.reason = this.activity_items.reason;
          actObj.manual_action = true;
          actObj.files = [];
          actObj.factory_product_id = factProd.id;
          actObj.product_files = [factProd.front_image, factProd.back_image];

          let fileObj = {};
          fileObj.file = null;
          fileObj.file_type = 'object';
          fileObj.side = 'front'
          actObj.files.push(fileObj);
          this.activity_items.activity_item_data.push(actObj);

        }
        if(this.activity_items.activity_item_data.length > 0)
          this.activity_navigation_index = 0;
        this.$modal.show('production-files-modal');
        this.modalType = 'production_sample';

      },
    changeSampleFile(files, act_item_index, file_index) {
      if (this.modalType === "test_sample") {
        this.design_approval_activity_item_data[act_item_index].files[file_index].file = files[0];
      } else {
        this.activity_items.activity_item_data[act_item_index].files[file_index].file = files[0];
      }
    },
    setSampleImage(act_item_index, file_index) {
      if (this.modalType === "test_sample") {
        return URL.createObjectURL(this.design_approval_activity_item_data[act_item_index].files[file_index].file);
      } else {
        return URL.createObjectURL(this.activity_items.activity_item_data[act_item_index].files[file_index].file);
      }
    },
    getProductionFileExtention(act_item_index, file_index){
      return this.getFileExtension(this.activity_items.activity_item_data[act_item_index].files[file_index].file.name);
    },
      navigateSampleFiles(direction) {
        
        if (direction == 'next') {
          if (this.validateSampleFiles()) {
            if (this.modalType == "test_sample") {
              let limit = this.design_approval_activity_item_data.length;
              if ((this.design_approval_activity_navigation_index + 1) < limit) {
                this.design_approval_activity_navigation_index++
              }
            } else {
              let limit = this.activity_items.activity_item_data.length;
              if ((this.activity_navigation_index + 1) < limit) {
                this.activity_navigation_index++
              }
            }
          } else {
            this.showToast('Please upload front/back sample file');
          }
        } else {
          if (this.modalType === "test_sample") {
            if ((this.design_approval_activity_navigation_index - 1) >= 0) {
              this.design_approval_activity_navigation_index--
            }
          } else {
            if ((this.activity_navigation_index - 1) >= 0) {
              this.activity_navigation_index--
            }
          }
        }

      },
      deleteFile(act_item_index, file_index) {
        if (this.modalType === "test_sample") {
          this.design_approval_activity_item_data[act_item_index].files[file_index].file = null;
        } else {
          this.activity_items.activity_item_data[act_item_index].files[file_index].file = null;
        }
      },
    moveOrderStatus(order_item, order_item_index){
      this.activity_items.order_move = 1
      this.activity_items.order_item_status = null
      if (this.move_order_to_status === null){
        this.showToast('Please select move order option');
        return false
      } else if (!this.move_order_reason) {
        this.showToast('Please state reason for moving the order');
        return false
      } else{
        let add_files = false
        if(this.move_order_to_status == FACTORY_APPROVE_REJECT){
          this.activity_items.order_item_status = ORDERAPPROVE;
          this.activity_navigation_index = 0;
          this.showArtworkDesigns(order_item, order_item_index, order_item.status_activities.length - 1);
          return ;
        }
        else if(this.move_order_to_status == CUSTOMERREVIEW){
          this.activity_items.order_item_status = CUSTOMERREVIEW;
          this.activity_navigation_index = 0;
          this.uploadSampleFiles(order_item, order_item_index, order_item.status_activities.length - 1);
          return ;
        }
        else if(this.move_order_to_status == FACTORYREVIEW){
          add_files = true
        }
        else if(this.move_order_to_status == ORDERAPPROVE){
          add_files = true
        }else if(this.move_order_to_status == PRODUCTIONFILESUPLOADED) {
          this.uploadProductionFiles(order_item, order_item_index)
          return ;
        }


        this.makeActivityData(order_item, order_item_index, this.move_order_to_status, add_files, this.move_order_reason, true);
        this.move_order_to_status = null;
        this.move_order_reason = null;
      }
    },
        addShippingDate(status, order_item, order, notify = false) {
          this.$store.commit('set', ['showLoader', true]);
          if (status == this.ORDERINPRODUCTION) {
            const estShippingDate = new Date(this.est_shipping_date);
            const today = new Date();

            if (estShippingDate < today) {
              this.$store.commit('set', ['showLoader', false]);
              this.showToast('Estimated shipping date cannot be in the past.', 'ERROR');
              return;
            }

            this.shipping_dates = [...this.shipping_dates, this.est_shipping_date];

            let url = `customer-orders/${order_item.id}/est-shipping-date`

            http.post(url, { shipping_dates: this.shipping_dates })
                .then(async (successResponse) => {
                  await this.getOrderDetail();
                  if (notify) {
                    this.$store.commit('set', ['showLoader', true]);
                    if (status == this.ORDERINPRODUCTION) {
                      let url = `notify-customer-shipping-date/${order_item.id}/order/${order.id}`
                      if (this.est_shipping_date) {
                        http.post(url).then(async (successResponse) => {
                          this.$store.commit('set', ['showLoader', false]);
                          this.showToast(successResponse.data.message, 'SUCCESS');
                        })
                      } else {
                        this.showToast('Please save shipping date.', 'error')
                        this.$store.commit('set', ['showLoader', false]);
                      }
                    }
                  }
                  this.$store.commit('set', ['showLoader', false]);
                  this.enterShippingDates = false;
                  this.showToast('Shipping date added', 'SUCCESS');
                }).catch((errorResponse) => {
              this.$store.commit('set', ['showLoader', false]);
              console.log(errorResponse);
            });
          }
        },
        putOrderInProduction(status, order_item, order, order_item_index, notify = false, add_files) {
          this.makeActivityData(order_item, order_item_index, status, add_files);
          this.addShippingDate(status, order_item, order, notify);          
          this.isPutInProduction = false;
        },
        makeActivityData(order_item, order_item_index, status, add_files, move_order_reason = null, manual_action = false) {

          if (status == this.ORDERSHIPPED && this.activity_items.order_move == 0) {
            if (!this.activity_items.shipping_company) {
              this.showToast('Please select shipping company');
              return false
            }
            if (!this.activity_items.tracking_no) {
              this.showToast('Please provide tracking no.');
              return false
            }
          }

          this.activity_items.order_item_id = order_item.id
          this.activity_items.order_item_index = order_item_index
          this.activity_items.order_item_status = status
          this.activity_navigation_index = null

          this.activity_items.activity_item_data = [];

          for (let factProd of order_item.factory_products) {
            let actObj = {};
            actObj.action = null;
            actObj.status = status;
            actObj.reason = move_order_reason;
            actObj.manual_action = manual_action;
            actObj.message = '';
            actObj.files = [];

            actObj.factory_product_id = factProd.id;

            if (add_files) {
              let front_file = {};
              front_file.file =  factProd.front_image;
              front_file.file_type = '';
              front_file.side = 'front'
              actObj.files.push(front_file);

              let back_file = {};
              back_file.file = factProd.back_image;
              back_file.file_type = '';
              back_file.side = 'back'
              actObj.files.push(back_file);

            }

            this.activity_items.activity_item_data.push(actObj);
          }
          this.submitActivity('form_data');
        },

        validateSampleFiles() {
          let valid = true;

          if (this.modalType === "test_sample") {
            const item = this.design_approval_activity_item_data[this.design_approval_activity_navigation_index];
            if (!item || !item.files) return false;

            // If skip is active for this item, always allow navigation/submit
            if (
              item.skip_customer_approval &&
              item.skip_customer_approval.design_customer_approval === false
            ) {
              return true;
            }

            valid = item.files.every(obj => obj.file !== null);
          } else {
            const item = this.activity_items.activity_item_data[this.activity_navigation_index];
            if (!item || !item.files) return false;

            // If skip is active for this item, always allow navigation/submit
            if (
              item.skip_customer_approval &&
              item.skip_customer_approval.design_customer_approval === false
            ) {
              return true;
            }

            valid = item.files.every(obj => obj.file !== null);
          }

          return valid;
        },
        skipSampleApproval(design_activity_item, design_activity_index) {
          this.design_approval_activity_item_data[design_activity_index].skip_customer_approval.show_reason_modal = true;
        },
        closeMessage(design_activity_item, design_activity_index) {
          this.design_approval_activity_item_data[design_activity_index].skip_customer_approval.show_reason_modal = false;
          this.design_approval_activity_item_data[design_activity_index].skip_customer_approval.reason = null;
          this.design_approval_activity_item_data[this.design_approval_activity_navigation_index].skip_customer_approval.design_customer_approval = true;
        },
        updateReason() {
          if (this.design_approval_activity_item_data.length) {
            if (!((this.design_approval_activity_item_data.length - 1) == this.design_approval_activity_navigation_index)) {
              if (this.design_approval_activity_item_data[this.design_approval_activity_navigation_index].skip_customer_approval.show_reason_modal
                  && this.design_approval_activity_item_data[this.design_approval_activity_navigation_index].skip_customer_approval.reason !== null
                  && this.design_approval_activity_item_data[this.design_approval_activity_navigation_index].skip_customer_approval.reason !== ""
              ) {
                this.design_approval_activity_item_data[this.design_approval_activity_navigation_index].skip_customer_approval.design_customer_approval = false;
                this.design_approval_activity_item_data[this.design_approval_activity_navigation_index].skip_customer_approval.show_reason_modal = false;
                this.navigateSampleFiles('next');
              } else {
                this.showToast('Please provide a valid reason to skip');
              }
            } else {
              this.design_approval_activity_item_data[this.design_approval_activity_navigation_index].skip_customer_approval.design_customer_approval = false;
              this.design_approval_activity_item_data[this.design_approval_activity_navigation_index].skip_customer_approval.show_reason_modal = false;
              this.submitSampleFiles('test_sample');
            }
          }
        },
        submitSampleFiles(modelType = null) {
          if (this.validateSampleFiles(modelType)) {
            this.submitActivity('form_data')
          } else {
            this.showToast('Please upload front/back sample file');
          }
        },
        showPreview(activity_item, factory_id) {
            this.front_preview = `${activity_item.activity_files[0].url}`
            this.back_preview = `${activity_item.activity_files[1].url}`
            this.$modal.show('product-preview')
          },

          sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
          },

          async downloadImages() {
            this.loadingPreviewImages = true;

            try {
              const urls = [];
              const imageNames = [];

              // Determine image names
              const timestamp = this.getCurrentDatetime();
              const baseName = this.order.order_no || timestamp;

              // Build urls & names
            
                urls.push({ url: this.front_preview });
                imageNames.push(`${baseName}-front-preview.png`);

                if (this.back_preview && this.back_preview !== "null" && this.back_preview !== null) {
                  urls.push({ url: this.back_preview });
                  imageNames.push(`${baseName}-back-preview.png`);
                }

              // Filter invalids
              const valid = urls.filter(u => u.url && u.url !== "null");
              if (!valid.length) {
                this.loadingPreviewImages = false;
                this.showToast("Images not found!", "ERROR");
                return;
              }

              

              // Tune this delay if needed (ms). 1000–2000 generally works across browsers.
              const DELAY_MS = 3000;

              for (let i = 0; i < valid.length; i++) {
                const imageUrl = valid[i].url;
                const filename = imageNames[i] ?? `image_${i + 1}.png`;

                // Add a small unique token to prevent caching/overlap
                const uniqueToken = `${Date.now()}_${i}`;
                const downloadUrl = `${process.env.VUE_APP_BASE_URL}/get-svg?path=${encodeURIComponent(
                  imageUrl
                )}&file_name=${encodeURIComponent(filename)}&_dl=${uniqueToken}`;

                // Create anchor, append, click
                const anchor = document.createElement("a");
                anchor.href = downloadUrl;
                anchor.download = filename;
                anchor.style.display = "none";
                anchor.setAttribute("data-download-index", String(i));
                document.body.appendChild(anchor);

                // Trigger the download (user-initiated click)
                anchor.click();

                // Wait long enough for the browser to begin the download before removing anchor / starting next
                await this.sleep(DELAY_MS);

                // Cleanup
                if (document.body.contains(anchor)) {
                  document.body.removeChild(anchor);
                }

                
              }

              this.loadingPreviewImages = false;
              this.showToast("Images downloaded successfully!", "SUCCESS");
            } catch (error) {
              this.loadingPreviewImages = false;
              this.showToast("Error downloading images: " + (error.message || "Unknown error"), "ERROR");
              console.error("Download error:", error);
            }
          },
          async showOrderDetails($event, activity_item, factory_id, download) {
            let factory_product = activity_item.factory_products.filter((factory_product) => {
              return factory_product.id === factory_id
            });
            this.active_order_item_id = activity_item.id;
            await $event.stopPropagation();
            this.front_preview = activity_item && `${factory_product[0].front_image}`;
            this.back_preview = activity_item && `${factory_product[0].back_image}`;

            factory_product[0].custom_names = filter(factory_product[0].custom_texts, ["type", "name"]);
            factory_product[0].custom_numbers = filter(factory_product[0].custom_texts, ["type", "number"]);
            this.factory_product = factory_product[0];
            this.font_file = activity_item.font_file;

            // let content = await this.fetchUrlContent(this.factory_product.production_url);
            //todo need to change custom text show logic
            // this.production_content = await this.parseSvgString(content);
            if (download) {
              // this.downloadFile(this.production_content);
              if (Object.prototype.hasOwnProperty.call(this.factory_product, 'svg_url') && this.factory_product.svg_url) {
                let file_name = `${this.getCurrentDatetime()}.svg`;
                if(this.order.order_no){
                  file_name = `${this.order.order_no}.svg`;
                }
                this.downloadProductionFile(this.factory_product.svg_url, file_name);
              } else {
                this.downloadFile(this.production_content);
              }

            } else {
              this.product_texts = [];
              this.product_numbers = [];
              this.roster_details = [];
              this.custom_logos = [];
              if (Object.prototype.hasOwnProperty.call(this.factory_product, 'product_custom_texts')) {
                this.factory_product.product_custom_texts.forEach((product_custom_text) => {
                  if (product_custom_text.type === 'name' || product_custom_text.type === 'common' || product_custom_text.type === 'team_name') {
                    product_custom_text.items.forEach((item) => {
                      this.product_texts.push({...item, ...{font_family: product_custom_text.font_family}});
                    })
                  }
                  if (product_custom_text.type === 'number') {
                    product_custom_text.items.forEach((item) => {
                      this.product_numbers.push({...item, ...{font_family: product_custom_text.font_family}})
                    })
                  }
                })
              }
              let temp_array = [];
              if (Object.prototype.hasOwnProperty.call(this.factory_product, 'product_custom_text_objects')) {
                if (Object.prototype.hasOwnProperty.call(this.factory_product.product_custom_text_objects, 'roster') && this.factory_product.product_custom_text_objects.roster.length > 0) {
                  this.factory_product.product_custom_text_objects.roster.forEach((roster_item, rosterIndex) => {
                    if (Object.prototype.hasOwnProperty.call(roster_item, 'name') && roster_item.name.items.length > 0 && Object.prototype.hasOwnProperty.call(roster_item, 'number') && roster_item.number.items.length > 0) {
                      roster_item.name.items.forEach((item, index) => {
                        temp_array[rosterIndex] = {name: item.svg};
                      })
                      roster_item.number.items.forEach((item, index) => {
                        this.roster_details[rosterIndex] = {
                          number: item.svg,
                          name: temp_array[rosterIndex].name,
                          size: roster_item.size,
                          quantity: roster_item.quantity
                        };
                      })
                    } else if (Object.prototype.hasOwnProperty.call(roster_item, 'name') && roster_item.name.items.length > 0) {
                      roster_item.name.items.forEach((item, index) => {
                        this.roster_details[rosterIndex] = {
                          number: null,
                          name: item.svg,
                          size: roster_item.size,
                          quantity: roster_item.quantity
                        }
                      })
                    } else if (Object.prototype.hasOwnProperty.call(roster_item, 'number') && roster_item.number.items.length > 0) {
                      roster_item.number.items.forEach((item, index) => {
                        this.roster_details[rosterIndex] = {
                          number: item.svg,
                          name: null,
                          size: roster_item.size,
                          quantity: roster_item.quantity
                        }
                      })
                    } else {
                      this.roster_details[rosterIndex] = {
                        number: null,
                        name: null,
                        size: roster_item.size,
                        quantity: roster_item.quantity
                      }
                    }

                  });
                }
                if (Object.prototype.hasOwnProperty.call(this.factory_product.product_custom_text_objects, 'common') && this.factory_product.product_custom_text_objects.common.length > 0) {
                  let index_for_common = this.roster_details.length;
                  this.factory_product.product_custom_text_objects.common.forEach((common_item, commonIndex) => {
                    common_item.items.forEach((item, index) => {
                      this.roster_details[index_for_common + commonIndex] = {
                        number: null,
                        name: item.svg,
                        size: null,
                        quantity: null
                      }
                    })
                  });
                }
              }
              if (Object.prototype.hasOwnProperty.call(this.factory_product, 'custom_logos') && this.factory_product.custom_logos.length > 0) {
                this.factory_product.custom_logos.forEach((custom_logo) => {
                  custom_logo.show_vectorized_loader = false
                  custom_logo.show_vectorized_preview_loader = false
                  if (custom_logo.id !== null) {
                    this.custom_logos.push(custom_logo);
                  }
                });
              }
              this.$modal.show('order-detail');
            }
          },
          closeFactoryDetail() {
            this.factory_product = {};
            this.active_order_item_id = null;
            this.custom_logos = [];
            this.$modal.hide('order-detail');
          },
          async fetchUrlContent(url) {
            let fetch_content = await fetch(url);
            let url_content = await fetch_content.text();
            return url_content;
          },
          async parseSvgString(svg_string) {
            if (svg_string.substring(0, svg_string.lastIndexOf("</g>")) !== '') {
              let self = this;
              let production_content = "";
              this.roster_detail = [];

              //Applying Text and Logo on SVG
              let custom_logos_texts_string = "";
              let companies_name = [];

              // let elements = await self.getDocFromString(self.factory_product.custom_text_svgs);

              let custom_texts = self.factory_product.product_custom_texts;

              let custom_name_index = custom_texts.findIndex((custom) => {
                let is_roster_name = this.factory_product.product_roster_detail.findIndex((roaster) => roaster.text == custom.text);
                return custom.type === 'name' && custom.text && is_roster_name != -1;
              })

              let custom_number_index = custom_texts.findIndex((custom) => {
                let is_roster_number = this.factory_product.product_roster_detail.findIndex((roaster) => roaster.text == custom.number);
                return custom.type === 'number' && custom.text && is_roster_number != -1;
              })

              let custom_text_svgs = self.factory_product.custom_text_svgs;

              let sorted_custom_text_svgs = [];
              if (custom_name_index > -1) {
                if (this.factory_product.product_roster_detail.findIndex((roaster) => roaster.text == custom_texts[custom_name_index].text) > -1) {
                  sorted_custom_text_svgs.push({
                    svg: custom_text_svgs[custom_name_index],
                    type: 'name'
                  });
                }
              }

              if (custom_number_index > -1) {
                if (this.factory_product.product_roster_detail.findIndex((roaster) => roaster.number == custom_texts[custom_number_index].text) > -1) {
                  sorted_custom_text_svgs.push({
                    svg: custom_text_svgs[custom_number_index],
                    type: 'number'
                  });
                }
              }

              let rest_of_text_svg = [];
              custom_text_svgs.forEach((custom_text_svg, index) => {
                if (index !== custom_name_index && index !== custom_number_index) {
                  return rest_of_text_svg.push({
                    svg: custom_text_svg,
                    type: 'common'
                  });
                }
              });


              rest_of_text_svg.forEach((text_svg) => {
                sorted_custom_text_svgs.push(text_svg);
              });


              for (let [indexrstr, roster_detail] of self.factory_product.roster_detail.entries()) {
                let text = "";
                let number = "";
                let name_height = "";
                let number_height = "";
                companies_name = [];
                for (let [index, custom_text_svg] of sorted_custom_text_svgs.entries()) {
                  let element = await self.getDocFromString(custom_text_svg.svg);
                  let el = element ? element.querySelector('g') : null;
                  if (custom_text_svg.type === 'name' && el) {
                    let tspan = el.querySelector('tspan');
                    if (tspan) {
                      tspan.innerHTML = roster_detail.text
                      tspan.setAttribute('x', 0);
                      tspan.setAttribute('y', 0);

                      text = new XMLSerializer().serializeToString(el.querySelector('text'));
                      name_height = self.factory_product.custom_texts[custom_name_index].originalHeight;
                    }

                  } else if (custom_text_svg.type === 'number' && el) {
                    let tspan = el.querySelector('tspan');
                    if (tspan) {
                      tspan.innerHTML = roster_detail.number
                      tspan.setAttribute('x', 0);
                      tspan.setAttribute('y', 0);

                      number = new XMLSerializer().serializeToString(el.querySelector('text'));
                      number_height = self.factory_product.custom_texts[custom_number_index].originalHeight;
                    }


                  } else {
                    if (el) {
                      let tspan = el.querySelector('tspan');
                      if (tspan) {
                        tspan.setAttribute('x', 0);
                        tspan.setAttribute('y', 0);
                        companies_name.push({
                          name: new XMLSerializer().serializeToString(el.querySelector('text')),
                          size: 'For ALL'
                        })
                      }
                      let custom_logos_texts_string_mod = new XMLSerializer().serializeToString(el);
                      custom_logos_texts_string += custom_logos_texts_string_mod;
                    }

                  }


                }

                this.roster_detail.push(
                    {
                      text: text,
                      number: number,
                      size: roster_detail.size,
                      name_height: name_height,
                      number_height: number_height,
                    }
                );
              }
              companies_name.forEach((company) => {
                this.roster_detail.push(
                    {
                      text: company.name,
                      number: null,
                      size: company.size,
                      name_height: null,
                      number_height: null
                    }
                )
              })
              for (let custom_logo_svg of self.factory_product.custom_logo_svgs) {
                let logo_url = $(custom_logo_svg).find("img:eq(0)").attr("xlink:href")
                if (logo_url) {
                  try {

                    let base64_logo = await urlToBase64(logo_url);
                    custom_logo_svg = custom_logo_svg.replace(logo_url, base64_logo)
                  } catch (errorResponse) {
                    console.log(errorResponse)
                  }
                }
                custom_logos_texts_string += custom_logo_svg;
              }
              if (custom_logos_texts_string) {
                svg_string = svg_string.substring(0, svg_string.lastIndexOf("</g>"));
                // svg_string += `${custom_logos_texts_string}\n`
                // svg_string += `${this.getSVGTable('Roaster Detail',['Name','Number','Size','Dimension'],this.roster_detail)}\n</g>\n</svg>`
                svg_string += `${this.getSVGPattern(this.roster_detail, this.factory_product.measurement_ratio)}\n`
                if (!(this.factory_product.custom_logos.length == 1 && this.factory_product.custom_logos[0].url === null)) {
                  svg_string += `${await this.getLogoPattern(this.factory_product.custom_logos, this.factory_product.measurement_ratio)}`
                }
                svg_string += `\n</g>\n</svg>`;
              }
              let svg_doc = await self.getDocFromString(svg_string);
              this.production_file_info = {
                width: $(svg_doc).find("svg").eq(0).attr("width"),
                height: $(svg_doc).find("svg").eq(0).attr("height")
              }
              let scaled_file_info = {
                width: parseFloat(this.production_file_info.width) * 0.10440000,
                height: parseFloat(this.production_file_info.height) * 0.10440000,
              };


              //Applying Color on SVG
              self.factory_product.svg_groups.forEach((svg_group_item) => {
                $(svg_doc).find(`[id][fill]`).each(function (doc_item) {
                  let doc_elem_id = $(this).attr("id");
                  if (doc_elem_id) {
                    doc_elem_id = doc_elem_id.search("_") >= 0 ? doc_elem_id.substring(0, doc_elem_id.search("_")) : doc_elem_id
                    if (doc_elem_id.toLowerCase() == svg_group_item.id.toLowerCase()) {
                      $(this).attr("fill", svg_group_item.color);
                    }
                  }
                })
              })

              //Add Fonts to SVgs Start
              let font_style = document.createElementNS("http://www.w3.org/2000/svg", "style");
              if (self.font_file && self.font_file.length > 0) {
                for (let font of self.font_file) {
                  font_style.innerHTML += ` @font-face{ font-family: ${font.file_name}; src: url('${font.font_url}');  }`;
                }
              }
              $(svg_doc).find("svg").eq(0).prepend(font_style)
              //Add Fonts to SVgs End

              //Add Front and Back Images Side wise to svg
              let group_back_image_tag = document.createElementNS("http://www.w3.org/2000/svg", "g");
              group_back_image_tag.setAttribute('transform', `matrix(1 0 0 1 ${parseFloat(self.production_file_info.width)} 0)`);
              let back_image = document.createElementNS("http://www.w3.org/2000/svg", "image");
              back_image.setAttribute('xlink:href', `${self.storage_url}/${self.factory_product.back_image}`);
              back_image.setAttribute('height', `${(parseFloat(self.production_file_info.height) / 2)}px`);
              back_image.setAttribute('width', `${(parseFloat(self.production_file_info.height) / 2)}px`);
              group_back_image_tag.appendChild(back_image);
              $(svg_doc).find("g").eq(0).prepend(group_back_image_tag)


              let group_front_image_tag = document.createElementNS("http://www.w3.org/2000/svg", "g");
              group_front_image_tag.setAttribute('transform', `matrix(1 0 0 1 ${parseFloat(self.production_file_info.width)} ${(parseFloat(self.production_file_info.width) / 2) + 500})`);
              let front_image = document.createElementNS("http://www.w3.org/2000/svg", "image")
              front_image.setAttribute('xlink:href', `${self.storage_url}/${self.factory_product.front_image}`);
              front_image.setAttribute('height', `${(parseFloat(self.production_file_info.height) / 2)}px`);
              front_image.setAttribute('width', `${(parseFloat(self.production_file_info.height) / 2)}px`);
              group_front_image_tag.appendChild(front_image);
              $(svg_doc).find("g").eq(0).prepend(group_front_image_tag)

              //Add Front and Back Images Side wise to svg

              $(svg_doc).find("svg").eq(0).attr({
                "width": (scaled_file_info.width * 2) + 'px',
                height: scaled_file_info.height + 'px'
              });
              let view_box = svg_doc.querySelector('svg').getAttribute('viewBox');
              let view_box_dimensions = view_box.split(" ");

              svg_doc.querySelector('svg').setAttribute('viewBox', `${view_box_dimensions[0]} ${view_box_dimensions[1]} ${parseFloat(self.production_file_info.width) * 2} ${this.logo_pattern_last_value_y ? this.logo_pattern_last_value_y : this.svg_pattern_last_value_y}`);
              production_content = new XMLSerializer().serializeToString(svg_doc);

              return production_content;
            } else {
              return 'No SVG Exists'
            }

            // self.$emit("update:production_file_obj", self.production_file_obj)
          },
          async downloadFile(production_content) {
            const production_file = document.getElementById(`production-file-${this.factory_product.product_id}`);
            if (!production_file) {
              let anchor = document.createElement('a');
              let svg_elem = await this.getDocFromString(production_content);
              this.production_file_info = {
                width: parseFloat(this.production_file_info.width) * 2,
                // height : this.production_file_info.height
                height: this.logo_pattern_last_value_y ? this.logo_pattern_last_value_y : this.svg_pattern_last_value_y,
              }
              $(svg_elem).find("svg").eq(0).attr(this.production_file_info);
              let svg_elem_content = new XMLSerializer().serializeToString(svg_elem);
              anchor.setAttribute('id', `production-file-${this.factory_product.product_id}`);
              anchor.setAttribute('href', 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg_elem_content));
              // anchor.setAttribute('download', `${cutting_file_obj.size_name}.svg`);
              let svg_name = `${this.getCurrentDatetime()}.svg`;
              if(this.order.order_no){
                svg_name = `${this.order.order_no}.svg`
              }
              anchor.setAttribute('download', svg_name);
              anchor.style.display = 'none';
              document.body.appendChild(anchor);
              anchor.click();
            } else {
              production_file.click();
            }


            // document.body.removeChild(anchor);
          },
          downloadLogo(id, url) {
            let logo_element = document.createElement('a');
            this.logo_selected_id = id;
            this.loading = true;
            http.get(`file/logo-download/${id}`).then((response) => {
              let logo = response.data.logo;
              let file_path = response.data.path;
              if (logo && file_path) {
                const d = new Date()
                let time = d.getTime()
                let url_split_array = file_path.split("/");
                let file_name = url_split_array[url_split_array.length - 1];
                logo_element.setAttribute('id', `${time}`);
                logo_element.setAttribute('href', logo);
                logo_element.setAttribute('download', `${file_name}`);
                logo_element.style.display = 'none';
                document.body.appendChild(logo_element);
                logo_element.click();
                document.body.removeChild(logo_element);
                this.loading = false;
                this.logo_selected_id = null;
              } else {
                this.showToast('Logo path is not valid');
                this.loading = false;
                this.logo_selected_id = null;
              }
            }).catch((errorResponse) => {
              this.loading = false;
              this.logo_selected_id = null;
            });

          },
          async getDocFromString(doc_string, type = "image/svg+xml") {
            let parser = new DOMParser();
            return parser.parseFromString(doc_string, type);
          },
          getSVGPattern(values, measurement_ratio) {
            return `
                <g xmlns="



                p://www.w3.org/2000/svg" transform="matrix(1 0 0 1 0 ${5000})" style="font-weight: bold;">
                    <text xml:space="preserve" font-family="gibson-bold-webfont" font-size="95.78" font-style="bold" paint-order="stroke">
                        <tspan x="0" y="0">Name </tspan>
                    </text>
                    <text xml:space="preserve" font-family="gibson-bold-webfont" font-size="95.78" font-style="bold" paint-order="stroke">
                        <tspan x="${1000}" y="0">Number </tspan>
                    </text>
                    <text xml:space="preserve" font-family="gibson-bold-webfont" font-size="95.78" font-style="bold" paint-order="stroke">
                        <tspan x="${2000}" y="0">Size </tspan>
                    </text>
                    <text xml:space="preserve" font-family="gibson-bold-webfont" font-size="95.78" font-style="bold" paint-order="stroke">
                        <tspan x="${3000}" y="0">Name Height </tspan>
                    </text>
                    <text xml:space="preserve" font-family="gibson-bold-webfont" font-size="95.78" font-style="bold" paint-order="stroke">
                        <tspan x="${4000}" y="0">Number Height </tspan>
                    </text>
                </g>
        ${values.map((value, index) => {
              return `
                <g xmlns="

                ://www.w3.org/2000/svg" transform="matrix(1 0 0 1 0 ${5000})">
                <g transform="matrix(${measurement_ratio ? 1 / measurement_ratio : 1} 0 0 ${measurement_ratio ? 1 / measurement_ratio : 1} 0 ${500 + index * 1000})">
                     ${value.text ? value.text : ''}
                </g>
                <g transform="matrix(${measurement_ratio ? 1 / measurement_ratio : 1} 0 0 ${measurement_ratio ? 1 / measurement_ratio : 1} 1000 ${500 + index * 1000})">
                      ${value.number ? value.number : ''}
                </g>
                <g transform="matrix(1 0 0 1 2000 ${500 + index * 1000})">
                    <text xml:space="preserve" font-family="gibson-bold-webfont" font-size="95.78" font-style="bold" paint-order="stroke">
                        <tspan x="0" y="0">${value.size ? value.size : ''} </tspan>
                    </text>
                </g>
                <g transform="matrix(1 0 0 1 3000 ${500 + index * 1000})">
                    <text xml:space="preserve" font-family="gibson-bold-webfont" font-size="95.78" font-style="bold" paint-order="stroke">
                        <tspan x="0" y="0">${value.name_height ? value.name_height + 'cm /' + parseFloat(value.name_height / this.INCH_TO_CENTIMETER).toFixed(2) + 'in' : ''} </tspan>
                    </text>
                </g>
                <g transform="matrix(1 0 0 1 4000 ${500 + index * 1000})">
                    <text xml:space="preserve" font-family="gibson-bold-webfont" font-size="95.78" font-style="bold" paint-order="stroke">
                        <tspan x="0" y="0">${value.number_height ? value.number_height + 'cm /' + parseFloat(value.number_height / this.INCH_TO_CENTIMETER).toFixed(2) + 'in' : ''} </tspan>
                    </text>
                </g>
                ${this.svg_pattern_last_value_y = ((500 + index * 1000) + 5000)}
                </g>`

            })
            }
        `
          },
          async getLogoPattern(values, measurement_ratio) {
            let svg_group_el = `
        <g xmlns="http://www.w3.org/2000/svg" transform="matrix(1 0 0 1 0 ${this.svg_pattern_last_value_y + 500})" style="font-weight: bold;">
                    <text xml:space="preserve" font-family="gibson-bold-webfont" font-size="95.78" font-style="bold" paint-order="stroke">
                        <tspan x="0" y="0">Logo </tspan>
                    </text>
                    <text xml:space="preserve" font-family="gibson-bold-webfont" font-size="95.78" font-style="bold" paint-order="stroke">
                        <tspan x="${1000}" y="0">Side </tspan>
                    </text>
                    <text xml:space="preserve" font-family="gibson-bold-webfont" font-size="95.78" font-style="bold" paint-order="stroke">
                        <tspan x="${2000}" y="0">Size </tspan>
                    </text>
                </g>
       `;
            let index = 0;
            for (let index in values) {
              let value = values[index];
              let original_url = Object.prototype.hasOwnProperty.call(value, 'original_logo_url');
              let updated_url = original_url ? value.original_logo_url : value.url;
              if (updated_url !== null && updated_url !== undefined && updated_url !== "") {
                if (getFileExtensionType('raster', updated_url)) {
                  await urlToBase64(`${this.storage_url}/${updated_url}`).then(async (base64) => {
                    svg_group_el += `
                <g xmlns="http://www.w3.org/2000/svg" transform="matrix(1 0 0 1 0 ${this.svg_pattern_last_value_y + 500})">
                <g transform="matrix(1 0 0 1 0 ${500 + index * 1000})">
                    ${updated_url ? `<image xlink:href="${base64}" height="${(200 * value.scaleY) / measurement_ratio}px" width="${(200 * value.scaleX) / measurement_ratio}px"/>` : ''}
                </g>
                <g transform="matrix(1 0 0 1 1000 ${500 + index * 1000})">
                    <text xml:space="preserve" font-family="gibson-bold-webfont" font-size="95.78" font-style="bold" paint-order="stroke">
                        <tspan x="0" y="0">${value.side ? value.side : ''} </tspan>
                    </text>
                </g>
                <g transform="matrix(1 0 0 1 2000 ${500 + index * 1000})">
                    <text xml:space="preserve" font-family="gibson-bold-webfont" font-size="95.78" font-style="bold" paint-order="stroke">
                        <tspan x="0" y="0">${value.originalWidth ? value.originalWidth + 'cm x' + value.originalHeight + 'cm /' + parseFloat(value.originalWidth / this.INCH_TO_CENTIMETER).toFixed(2) + 'in x' + parseFloat(value.originalHeight / this.INCH_TO_CENTIMETER).toFixed(2) + 'in' : ''} </tspan>
                    </text>
                </g>
                ${this.logo_pattern_last_value_y = (((500 + index * 1000) + (this.svg_pattern_last_value_y + 500)) + 500)}
                </g>`
                  })
                } else {
                  svg_group_el += `
                <g xmlns="http://www.w3.org/2000/svg" transform="matrix(1 0 0 1 0 ${this.svg_pattern_last_value_y + 500})">
                <g transform="matrix(1 0 0 1 0 ${500 + index * 1000})">
                    ${updated_url ? `<image xlink:href="${this.storage_url}/${updated_url}" height="${(200 * value.scaleY) / measurement_ratio}px" width="${(200 * value.scaleX) / measurement_ratio}px"/>` : ''}
                </g>
                <g transform="matrix(1 0 0 1 1000 ${500 + index * 1000})">
                    <text xml:space="preserve" font-family="gibson-bold-webfont" font-size="95.78" font-style="bold" paint-order="stroke">
                        <tspan x="0" y="0">${value.side ? value.side : ''} </tspan>
                    </text>
                </g>
                <g transform="matrix(1 0 0 1 2000 ${500 + index * 1000})">
                    <text xml:space="preserve" font-family="gibson-bold-webfont" font-size="95.78" font-style="bold" paint-order="stroke">
                        <tspan x="0" y="0">${value.originalWidth ? value.originalWidth + 'cm x' + value.originalHeight + 'cm /' + parseFloat(value.originalWidth / this.INCH_TO_CENTIMETER).toFixed(2) + 'in x' + parseFloat(value.originalHeight / this.INCH_TO_CENTIMETER).toFixed(2) + 'in' : ''} </tspan>
                    </text>
                </g>
                ${this.logo_pattern_last_value_y = (((500 + index * 1000) + (this.svg_pattern_last_value_y + 500)) + 500)}
                </g>`
                }
              }


              ++index;
            }
            return svg_group_el;
          },
          getLogoPattern_old(values, measurement_ratio) {
            return `
                <g xmlns="http://www.w3.org/2000/svg" transform="matrix(1 0 0 1 0 ${this.svg_pattern_last_value_y + 500})" style="font-weight: bold;">
                    <text xml:space="preserve" font-family="gibson-bold-webfont" font-size="95.78" font-style="bold" paint-order="stroke">
                        <tspan x="0" y="0">Logo </tspan>
                    </text>
                    <text xml:space="preserve" font-family="gibson-bold-webfont" font-size="95.78" font-style="bold" paint-order="stroke">
                        <tspan x="${1000}" y="0">Side </tspan>
                    </text>
                    <text xml:space="preserve" font-family="gibson-bold-webfont" font-size="95.78" font-style="bold" paint-order="stroke">
                        <tspan x="${2000}" y="0">Size </tspan>
                    </text>
                </g>
        ${values.map((value, index) => {
              return `
                <g xmlns="http://www.w3.org/2000/svg" transform="matrix(1 0 0 1 0 ${this.svg_pattern_last_value_y + 500})">
                <g transform="matrix(1 0 0 1 0 ${500 + index * 1000})">
                    <image xlink:href="${this.storage_url}/${value.url ? value.url : ''}" height="${(200 * value.scaleY) / measurement_ratio}px" width="${(200 * value.scaleX) / measurement_ratio}px"/>
                </g>
                <g transform="matrix(1 0 0 1 1000 ${500 + index * 1000})">
                    <text xml:space="preserve" font-family="gibson-bold-webfont" font-size="95.78" font-style="bold" paint-order="stroke">
                        <tspan x="0" y="0">${value.side ? value.side : ''} </tspan>
                    </text>
                </g>
                <g transform="matrix(1 0 0 1 2000 ${500 + index * 1000})">
                    <text xml:space="preserve" font-family="gibson-bold-webfont" font-size="95.78" font-style="bold" paint-order="stroke">
                        <tspan x="0" y="0">${value.originalWidth ? value.originalWidth + 'cm x' + value.originalHeight + 'cm /' + parseFloat(value.originalWidth / this.INCH_TO_CENTIMETER).toFixed(2) + 'in x' + parseFloat(value.originalHeight / this.INCH_TO_CENTIMETER).toFixed(2) + 'in' : ''} </tspan>
                    </text>
                </g>
                ${this.logo_pattern_last_value_y = (((500 + index * 1000) + (this.svg_pattern_last_value_y + 500)) + 500)}
                </g>`
            })
            }
        `
          },
          /*
          * Item activity methods ends
          * * */

          async showMarkerActionButtons() {
            setTimeout(() => {
              this.showMarkerArea(0);
              this.showMarkerArea(1);
            }, 2000)
          },

          isMarkerAreaShown(marker_area_container_id) {
            return $(`#${marker_area_container_id}`).children().length > 0;
          },
          downloadProductionFile(path, filename) {
            // Create a new link
            const anchor = document.createElement('a');
            let url = `${process.env.VUE_APP_BASE_URL}/get-svg?path=${path}&file_name=${filename}`;
            anchor.href = url;
            anchor.download = filename;
            anchor.style.display = 'none';
            anchor.setAttribute('id', `${Math.random()}`);
            // Append to the DOM
            document.body.appendChild(anchor);
            anchor.click();
            // Remove element from DOM
            document.body.removeChild(anchor);
          },
          batchDownloadAssets(item = null, activity_index = null) {
            let factory_product = null;
            if (item && (activity_index != null && activity_index != -1)) {
              let items = this.order.items[item.order_item_index];
              let activity_item = item.activity_item_data[activity_index];
              factory_product = items.factory_products.find(factory_product => {
                return factory_product.id === activity_item.factory_product_id;
              })
            } else {
              factory_product = this.factory_product;
            }
            this.batch_loading = true;
            let zip_file_element = document.createElement('a');
            zip_file_element.setAttribute('href', `${this.api_url}/order/${this.order.id}/product/${factory_product.id}/extract-zip`);
            let zip_file_name = `order_${this.getCurrentDatetime()}_product_${factory_product.product_name}.xlsx`
            if(this.order.order_no){
              zip_file_name = `order_${this.order.order_no}_product_${factory_product.product_name}.xlsx`;
            }
            zip_file_element.setAttribute('download', zip_file_name);
            zip_file_element.style.display = 'none';
            zip_file_element.setAttribute('id', `${Math.random()}`);
            document.body.appendChild(zip_file_element);
            zip_file_element.click();
            setTimeout(() => {
              this.batch_loading = false;
            }, 5000);

          },
          downloadAttachment(file) {
            let attachment_element = document.createElement('a');
            this.selected_attachment.push(file.name);
            let index = this.selected_attachment.findIndex((attachment) => {
              return attachment === file.name;
            });
            let urls = [{url: file.url, ext: file.extension}];
            http.post(`convert-file-to-base64`, {urls: urls}).then((response) => {
              let attachment = response.data.image_urls[0].url;
              if (attachment) {
                const d = new Date()
                let time = d.getTime()
                attachment_element.setAttribute('id', `${time}`);
                attachment_element.setAttribute('href', attachment);
                attachment_element.setAttribute('download', `${file.name}.${file.extension}`);
                attachment_element.style.display = 'none';
                document.body.appendChild(attachment_element);
                attachment_element.click();
                document.body.removeChild(attachment_element);
                this.selected_attachment.splice(index, 1);
              } else {
                this.showToast('File path is not valid');
                this.selected_attachment.splice(index, 1);
              }
            }).catch((errorResponse) => {
              this.selected_attachment.splice(index, 1);
            });
          },
          canPerformCommentAction(comment_obj) {
            let self = this;
            if (self.auth_user) {
              return comment_obj.comment_by_id == self.auth_user.id && comment_obj.comment_by == "App\\Models\\User";
            } else {
              return false;
            }
          },
          evaluateRole(activity_comment) {
            if (Object.prototype.hasOwnProperty.call(activity_comment, "user") && activity_comment.user) {
              if (Object.prototype.hasOwnProperty.call(activity_comment.user, "userroles")) {
                if (activity_comment.user.userroles.length > 0) {
                  switch (activity_comment.user.userroles[0].name.toLowerCase()) {
                    case "factory":
                      return "Factory";
                    case "admin":
                      return "Merchant";
                    case "superadmin":
                      return "Custimoo Admin";
                    case "orderadministrator":
                      return "Order administrator";
                  }
                }
              } else {
                return "Customer";
              }

            } else {
              return "Customer"
            }
          },
          makeReorderMessage(factory_product_id, factory_products) {
            let factory_product = factory_products.find(item => item.id == factory_product_id);
            let message = '';
            if (factory_product) {
              if (factory_product.reorder_data) {
                const reorder_data = factory_product.reorder_data;
                const isPossibleReorder = 'is_possible_reorder' in factory_product && factory_product.is_possible_reorder;

                // AB#20682 defect 1: when the referenced order had no
                // order_number this printed the raw orders.id behind a '#',
                // which reads as a customer-facing order number and sent
                // support to an unrelated customer's order. orders.order_no is
                // NULL by design until Mark to Factory, so never fall back to
                // the primary key.
                const hasOrderNumber = reorder_data.order_number !== undefined
                  && reorder_data.order_number !== null
                  && reorder_data.order_number !== '';
                const reference = hasOrderNumber
                  ? `order #${reorder_data.order_number}`
                  : 'an earlier order';

                message = isPossibleReorder
                  ? `Note: Possible reorder of ${reference} `
                  : `Note: Reorder of ${reference} `;

                if (reorder_data.roster_change == true && reorder_data.design_change == true) {
                  message += 'with design and roster changes.';
                } else if (reorder_data.roster_change == true && reorder_data.design_change == false) {
                  message += 'with roster changes.';
                } else if (reorder_data.roster_change == false && reorder_data.design_change == true) {
                  message += 'with design changes.';
                } else {
                  message += 'with no modifications';
                }

                // AB#20682 defect 2: the possible-reorder branch tested
                // this.order.order_no — the CURRENT order — so the suffix was
                // suppressed exactly when the REFERENCED order was the
                // unconfirmed one.
                if (!hasOrderNumber) {
                  message += ' (order not confirmed)'
                }
              }
            }

            return message;
          },
          vectorizeLogo(logo_container, preview_logo = false) {
            const custom_logo = logo_container.item
            const post_data = {
              logo_url: custom_logo.original_logo,
              order_item_id: this.active_order_item_id,
              factory_product_id: this.factory_product.id,
              vectorizer_params: {},
              logo_index: custom_logo.logo_index
            };
            if (preview_logo) {
              post_data.vectorizer_params.mode = "preview";
            }
            let active_logo = this.custom_logos[logo_container.index];
            if (preview_logo) {
              custom_logo.vectorized_logo_info.show_preview_loader = true
            } else {
              custom_logo.vectorized_logo_info.show_vectorized_loader = true
            }
            this.custom_logos[logo_container.index] = active_logo
            http.post("vectorize_logo", post_data).then((successResponse) => {
              const response_data = successResponse.data;
              if (response_data.success) {
                const {vectorized_logo_info} = response_data.result;
                custom_logo.vectorized_logo_info = vectorized_logo_info
                this.downloadVectorizedFile(logo_container.index, custom_logo, preview_logo)
              } else {
                if (preview_logo) {
                  custom_logo.vectorized_logo_info.show_preview_loader = false
                } else {
                  custom_logo.vectorized_logo_info.show_vectorized_loader = false
                }
                showToast(response_data.message, "error");
              }
            }).catch((errorResponse) => {
              handleResponseException(errorResponse)
            });
          },

          downloadVectorizedFile(logo_index, custom_logo, preview_logo = false) {
            const vectorized_logo_info = custom_logo.vectorized_logo_info
            let file_url = vectorized_logo_info.vectorized_file_url;
            let file_name = vectorized_logo_info.vectorized_file_name;
            let file_extension = vectorized_logo_info.vectorized_file_extension;
            if (preview_logo) {
              file_url = vectorized_logo_info.preview_file_url;
              file_name = vectorized_logo_info.preview_file_name;
              file_extension = vectorized_logo_info.preview_file_extension;
            }
            const file_name_with_extension = `${file_name}.${file_extension}`
            file_url = `${this.storage_url}/${file_url}`
            if (preview_logo) {
              custom_logo.vectorized_logo_info.show_preview_loader = true
            } else {
              custom_logo.vectorized_logo_info.show_vectorized_loader = true
            }
            urlToBase64(file_url).then(base64Content => {
              const downloadLink = document.createElement('a');
              downloadLink.href = base64Content;
              downloadLink.download = file_name_with_extension; // Set the filename here
              downloadLink.style.display = 'none';
              document.body.appendChild(downloadLink);
              downloadLink.click();
              document.body.removeChild(downloadLink);
              if (preview_logo) {
                custom_logo.vectorized_logo_info.show_preview_loader = false
              } else {
                custom_logo.vectorized_logo_info.show_vectorized_loader = false
              }
            }).catch(errorResponse => {
              if (preview_logo) {
                custom_logo.vectorized_logo_info.show_preview_loader = false
              } else {
                custom_logo.vectorized_logo_info.show_vectorized_loader = false
              }
              handleResponseException(errorResponse)
            })
          },
          provideQuotePrice(order) {
            this.quote.quote_order_id = order.id;
            this.quote.quote_order_no = order.order_no? null : "Quote pending";
            this.quote.quote_text = '';
            this.$refs.quoteAcceptModal.show();
          },
          saveQuotePrice() {

            if (this.quote.quote_text == '') {
              this.showToast('please provide quote text.', 'ERROR');
              return false;
            }

            http.post(`/save-quote-price`, this.quote).then(response => {
              let message_type = 'SUCCESS'
              if (response.data.success) {
                this.quote.quote_order_id = '';
                this.quote.quote_order_no = '';
                this.quote.quote_text = '';
                this.$refs.quoteAcceptModal.hide();
                this.getOrderDetail();
                this.show_provide_quote_button = false;
              } else {
                message_type = 'ERROR'
              }
              this.showToast(response.data.message, message_type);
            }).catch(e => {
              this.showError(e.response.data.message)
            });

          },
          acceptQuote() {
            this.$modal.show('quote-modal')
          },
          evaluateClass(activity_item, status) {
            if(activity_item.activity_files && activity_item.activity_files.length > 0){
              if(activity_item.skip_customer_approval && status !== this.ORDERINPRODUCTION && ((activity_item.skip_customer_approval?.design_customer_approval === "false") || (activity_item.skip_customer_approval?.design_customer_approval === false))){
                return 'submit-block skipped';
              }
              else {
                return 'submit-block';
              }
            }
            else {
              if(activity_item.skip_customer_approval && status !== this.ORDERINPRODUCTION && ((activity_item.skip_customer_approval?.design_customer_approval === "false") || (activity_item.skip_customer_approval?.design_customer_approval === false))){
                return 'skipped';
              }
              else {
                return '';
              }
            }
          },
          async rejectQuote() {
            let order = this.order;
            this.$store.commit('set', ['showLoader', true]);
            let payload = {}
            payload['order_id'] = order.id
            http.post(`reject-quote-order`, payload).then(async (res) => {

              if(res.data.success){
                this.showToast(res.data.message, 'SUCCESS');
                this.getOrderDetail();
                this.show_provide_quote_button = false;
                this.show_quote_buttons = false;

              }else{
                this.showToast('ERROR! Could not cancel the order, please try again.', 'error')
              }
              this.$store.commit('set', ['showLoader', false]);
            })
          },
    async resetDownloadProductionFile() {
      this.start_download_production_file = false;
    },
    async getSizeProductionFile(item) {
      const product_custom_texts = this.factory_product.product_custom_texts;
      const custom_name_index = findIndex(product_custom_texts, { type: 'name' });
      const custom_number_index = findIndex(product_custom_texts, { type: 'number' });
      this.factory_product.product_custom_texts[custom_name_index].value = item.text;
      this.factory_product.product_custom_texts[custom_number_index].value = item.number;
      this.size_download = item.size;
      this.start_download_production_file = true;
    },
    async downloadActivityProductionFile(activity_files) {
      if(activity_files && activity_files.length > 0) {
        let activity_file = activity_files[0];
        let file_url = `${this.storage_url}/${activity_file.url}`
        const file_name_with_extension = `${activity_file.name}.${activity_file.extension}`
        this.$store.commit('set', ['showLoader', true]);
        const base64_files = await urlToBase64Backend(file_url)
        this.$store.commit('set', ['showLoader', false]);
        const dom_document = getDomDocument(true)
        base64_files.forEach((base64_file, base64_file_index) => {
          let dom_activity_file = dom_document.createElement("a");
          dom_activity_file.href = base64_file;
          dom_activity_file.download = file_name_with_extension
          dom_activity_file.click();
        })
      }
    },
    getCurrentDatetime() {
      const now = new Date();
      return now.toISOString().replace(/:/g, '-').split('.')[0];
      // Formats to "YYYY-MM-DDTHH-MM-SS" (compatible for filenames)
    },
    async openAWSFileFromOrder(order){
      try{      
        let order_id = order.id

        // Fetch the URL from the Laravel API
        this.$store.commit('set', ['showLoader', true]);
        const response = await http.get(`designfile/order/${order_id}`);
        this.$store.commit('set', ['showLoader', false]);
        const url = response.data.result.url;
        if(url){
          window.open(`${url}`, '_blank');
        }
      } catch (error) {
        console.error('Error fetching the PDF URL:', error);
      }
    },    
    async fetchEstimatedShippingDate(order_item_id) {
      try {
        const response = await http.post(`/order/get-shipping-date/${order_item_id}`);
        if (response.data && response.data.estimated_shipping_date) {
          this.est_shipping_date = response.data.estimated_shipping_date;
        }
      } catch (error) {        
        this.est_shipping_date = '';
      }
    },
    async handlePutInProduction(order_item) {      
      await this.fetchEstimatedShippingDate(order_item.id);
      this.isPutInProduction = true;
    },
    async handleEnterShippingDate(order_item) {      
      await this.fetchEstimatedShippingDate(order_item.id);
      this.enterShippingDates = true;
    }
  }
}


</script>


<style lang="scss" scoped>
.btn-send-for-approval{
    background-color: #219F84 ;
    color: #fff ;
    border: none;
  }
@mixin avatar{
  display: flex;
  font-size: 1rem;
  text-transform: uppercase;
  height: 30px;
  width: 30px;
  flex-shrink: 0;
  background: #009eda;
  color: #fff;
  align-items: center;
  justify-content: center;
  border-radius: 1000px;
}

.order-wrapper{
  padding: 10px;
  background: #efefef;

  .order-title{
    text-align: left;
  }

  .chevron{
    transform: rotate(-180deg);
    transition: 0.3s all ease;
  }
  .collapsed{
    .chevron{
      transform: rotate(0deg);
    }
  }

  .order-activities{
    background: #fff;
    border: 1px solid #ddd;
    padding: 0.75rem 1rem;
    text-align: left;
    border-radius: 5px;

    .activity-icon{
      display: flex;
      align-items: center;
      justify-content: center;
      height: 40px;
      width: 40px;
      border: 1px solid #219F84;
      color: #219F84;
      font-size: 1.2rem;
      border-radius: 1000px;
      flex-shrink: 0;
    }

    .activity-status{
      display: flex;
      align-items: flex-start;
      position: relative;

      &:after{
        content: "";
        background: #219F84;
        display: block;
        position: absolute;
        width: 1px;
        left: 20px;
        top: 40px;
        bottom: -2rem;
      }

      &+.activity-status{
        margin-top: 2rem;
      }

      &:last-child{
        &:after{
          display: none;
        }
      }

      &.active{
        .activity-icon{
          background: #219F84;
          color: #fff;
        }
      }
      .activity-content{
        .activity-title{
          padding-left: 0.5rem;
          font-size: 1rem;
          font-weight: 600;
          margin-top: 0.5rem;

          .date-time{
            color: #999;
            margin-left: 5px;
            font-weight: normal;
            font-size: smaller;
          }
        }

        .images-grid{
          .actions{
            display: inline-flex;
            align-items: flex-start;
            gap: 7px;

            .btn{
              padding: 0;
              border: none;
              font-size: 1rem;
              transition: 0.2s ease all;

              &:hover{
                opacity: 0.85;
              }

              &.reject{
                color: #D53943;
              }
              &.approve{
                color: #219F84;
              }
            }
          }
          img{
            max-height: 150px;
            height: auto;
            border-radius: 4px;
            max-width: calc(50% - 5px);
          }
        }
      }

      .feedback-row{
        padding: 0.5rem 0.7rem;
        display: inline-flex;
        gap: 0.7rem;
        background: #E1E6EA;
        border-radius: 5px;
        flex-shrink: 0;
        transition: 0.2s ease all;
        cursor: pointer;

        &:hover{
          box-shadow: inset 0 0 0 1000px rgba(0,0,0,0.1);
        }

        .feedback-images{
          display: flex;
          gap: 10px;
          img{
            height: 100px;
          }
        }
      }
    }
  }

  .comment-box{
    width: 100%;
    max-width: 600px;
    background: #efefef;
    padding:0.7rem;
    border-radius: 5px;
    border: 1px solid #e6e6e6;
    position: relative;

    textarea{
      border: none;
      resize: none;
    }

    .comment-avatar{
      @include avatar;

      &.close{
        background: #c80b0b;
        opacity: 0.9;
        height: 22px;
        width: 22px;
        font-size: 1.1rem;
        position: absolute;
        top: -11px;
        right: -11px;
        cursor: pointer;
      }
    }

    button{
      flex-shrink: 0;
    }
  }
  

  .comment-row{
    .comment-avatar{
      @include avatar;
      background: #42b983;
    }

    .comment-msg{
      background: #E1E6EA;
      padding: 0.5rem 1.5rem 0.5rem 0.7rem;
      border-radius: 5px;
      display: flex;
      flex-direction: column;
      position: relative;
      max-width: 800px;

      .comment-action{
        position: absolute;
        right: 5px;
        top: 3px;
        ul{
          list-style: none;
          li{
            &+li{
              border-left: 1px solid #ccc;
              padding-left: 0.5rem;
            }

            a{
              &:hover{
                color: #1e8f77;
              }
            }
          }
        }

        button{
          padding: 0;
          border: none;
          background: none;
        }
      }
    }

    .comment-time{
      text-align: right;
      font-size: 0.9em;
      white-space: nowrap;
      color: rgba(0,0,0,0.4);
      align-self: flex-end;
    }
  }
}
.actions.nested-actions{
  background: transparent;
  color: #666;
  align-self: start;
  border: none;
  padding: 0;
  position: absolute;
  top: 5px;
  right: 5px;
  transition: 0.2s ease all;

  &:hover{
    color: #219F84;
  }
}
.actions .btn{
  justify-content: center;
  text-align: center;
  color: white;
  background: #219F84;
  border: none;
  padding: 0.4rem 1rem !important;
  white-space: nowrap;
}
.btn-submit-sample{
  color:white;
  background: #219F84;
}

.submit-block{
  padding: 10px;
  border-radius: 10px;
  border: 1px solid #eee;
  cursor:pointer;
  transition: 0.2s ease all;
  max-width: 100%;

  &:hover{
    background: #f3f3f3;
  }

  &>.d-flex{
    gap: 10px;
    max-width: 100%;

    &:empty{
      display: none !important;
      margin-bottom: 7px;
    }
  }
}

.comment-image{
  width:100%;
  height:100%;
  object-fit: contain;
  background: #ccc;
  border: 1px solid #bbb;
}

.activity-content {
  max-width: calc(100% - 20px);

  .feedback-text {
    padding: 0 5px;
    width: 100%;

    &+.feedback-text{
      border-top: 1px solid #ccc;
      margin-top: 0.5rem;
    }
  }
}
.skipped {
  position: relative;
}

.skipped-block {
  position: relative;
  overflow: hidden; /* Prevent overflow */
}
ul, li{
  list-style: none;
  padding: 0;
}
.shipping-dates-container{
  display: flex;
  flex-direction: column-reverse;
}
.shipping-dates-wrapper{
  border-radius: 15px;
}
h1{
  font-size: 1.1rem;
  font-family: sans-serif;
}
.shipping-dates{
  border-radius: 12px;
  position: relative;
}

.shipping-dates-list {
  padding-bottom: 1.5rem;
  border-left: 1px solid #219F84;
  position: relative;
  padding-left: 20px;
  &:last-child{
    border: 0px;
    padding-bottom: 0;
  }
  &:before{
    content: '';
    width: 15px;
    height: 15px;
    background: white;
    border: 1px solid #219F84;
    border-radius: 50%;
    position: absolute;
    left: -8px;
    top: 0px;
  }
}
.skipped::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  background-color: #219F84;
  color: white;
  font-size: 14px; /* Adjust font size */
  font-weight: bold;
  text-align: center;
  padding: 25px;
  width: 135px; /* Increase width to ensure space for text */
  height: 135px; /* Increase height for the triangle */
  clip-path: polygon(0 0, 100% 0, 0 100%);
  display: flex;
  align-items: flex-end; /* Align text at the top of the triangle */
  justify-content: flex-start;
  transform: translate(-15%, -15%); /* Fine-tune positioning */
  writing-mode: vertical-rl; /* Optional: Rotates text for better fit */
  line-height: 1.2;
  opacity: 0.8;
  z-index: 1;
}

.skipped::after {
  content: 'Sample\AOmitted';
  position: absolute;
  top: 19px;
  left: 10px;
  right: 309px;
  font-size: 14px;
  color: white;
  font-weight: bold;
  transform: rotate(-45deg);
  z-index: 10;
  white-space: pre;
}
.time{
  color: #2a2839;
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
}
p{
  color: #4f4f4f;
  font-family: sans-serif;
  line-height: 1.5;
  margin-top:0.4rem;
}
.resolved-comment {
  right: -280px !important;
}
.unresolved-comment {
  right: -300px;
}
.shipping-btn {
  height: 50px !important;
}
</style>
